import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import gql from 'graphql-tag'
import { Query, ApolloConsumer, withApollo } from 'react-apollo'
import Select from 'react-select'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import { DateTimePicker } from 'material-ui-pickers'
import CustomTabs from '../../Modules/CustomTabs'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import moment from 'moment'
import Loader from '../../../components/common/Loader'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import {
  MenuItem,
  Checkbox,
  InputLabel,
  Switch,
  Typography
} from '@material-ui/core'
import Countries from '../../Modules/Countries'
import States from '../../Modules/States'
import convertToSnakeCase from '../../../utils/conertSnakeFormat'

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  italicizedText: {
    fontStyle: 'italic'
  }
})

const ADD_CLIENTS = gql`
  mutation clientSignup(
    $username: String!
    $password: String!
    $accountType: String
    $clientName: String
    $email: String!
    $contactPerson: String!
    $contactNumber: String!
    $landlineNumber: String!
    $address: String!
    $city: String!
    $state: Int!
    $country: Int!
    $pincode: Int!
    $panNumber: String
    $gst: String
    $planId: Int
    $solution: String
    $billingMode: Int
    $salesPersonId: Int
    $clientType: String
    $timezone: String!
    $lat: Float
    $long: Float
    $partnerLoginId: Int
    $resellerLoginId: Int
    $licenseTypeId: Int
    $typeOfClient: ClientPartnerType
    $expiryDate: String
    $registrationType: String!
    $customerAcquisitionType: String!
    $directCustomer: String
    $directCustomerType: String
    $directCustomerSAPCode: String
    $indirectCustomerType: String
    $channelPartnerType: String
    $indirectCustomerName: String
    $indirectCustomerUniqueId: String
    $customerLocation: String!
    $customerAddress: String!
    $isSecondaryContact: Boolean
    $secondaryContactName: String
    $secondaryContactNumber: String
    $secondaryLandlineNumber: String
    $secondaryEmail: String
    $additionalContactNumbers: String
    $shippingAddress: String
    $shippingCountry: Int
    $shippingState: Int
    $shippingCity: String
    $shippingPincode: Int
    $minimumTrackedDays: Int
    $packetThreshold: Int
    $prorata: Int
    $addressEffectiveDate: String
    $zonalManager: String!
    $keyAccountManager: String!
    $zone: String!
    $serviceManager: String!
    $customerSuccessManager: String!
    $channelPartnerName: String
    $channelPartnerSAPCode: String
    $litemode: String!
    $is_sim_tracking: Boolean
    $customerNameToBeDisplayed: String!
    $totalPotentialVehicles: Int!
    $planType: String
    $videoTelematicsType: String
    $serviceType: String!
    $clientCategory: String!
    $stateManager: String!
    $territoryManager: String
    $salesHead: String
    $clusterHead: String
    $stateHead: String
    $cityManager: String
    $operationsManager: String
    $actionDashboardCategory: String
  ) {
    clientSignup(
      username: $username
      password: $password
      accountType: $accountType
      clientName: $clientName
      email: $email
      contactPerson: $contactPerson
      contactNumber: $contactNumber
      landlineNumber: $landlineNumber
      address: $address
      city: $city
      state: $state
      country: $country
      pincode: $pincode
      panNumber: $panNumber
      gst: $gst
      planId: $planId
      solution: $solution
      billingMode: $billingMode
      salesPersonId: $salesPersonId
      clientType: $clientType
      timezone: $timezone
      lat: $lat
      long: $long
      partnerLoginId: $partnerLoginId
      resellerLoginId: $resellerLoginId
      licenseTypeId: $licenseTypeId
      typeOfClient: $typeOfClient
      expiryDate: $expiryDate
      registrationType: $registrationType
      customerAcquisitionType: $customerAcquisitionType
      directCustomer: $directCustomer
      directCustomerType: $directCustomerType
      directCustomerSAPCode: $directCustomerSAPCode
      indirectCustomerType: $indirectCustomerType
      channelPartnerType: $channelPartnerType
      indirectCustomerName: $indirectCustomerName
      indirectCustomerUniqueId: $indirectCustomerUniqueId
      customerLocation: $customerLocation
      customerAddress: $customerAddress
      isSecondaryContact: $isSecondaryContact
      secondaryContactName: $secondaryContactName
      secondaryContactNumber: $secondaryContactNumber
      secondaryLandlineNumber: $secondaryLandlineNumber
      secondaryEmail: $secondaryEmail
      additionalContactNumbers: $additionalContactNumbers
      shippingAddress: $shippingAddress
      shippingCountry: $shippingCountry
      shippingState: $shippingState
      shippingCity: $shippingCity
      shippingPincode: $shippingPincode
      minimumTrackedDays: $minimumTrackedDays
      packetThreshold: $packetThreshold
      prorata: $prorata
      addressEffectiveDate: $addressEffectiveDate
      zonalManager: $zonalManager
      keyAccountManager: $keyAccountManager
      zone: $zone
      serviceManager: $serviceManager
      customerSuccessManager: $customerSuccessManager
      channelPartnerName: $channelPartnerName
      channelPartnerSAPCode: $channelPartnerSAPCode
      litemode: $litemode
      is_sim_tracking: $is_sim_tracking
      customerNameToBeDisplayed: $customerNameToBeDisplayed
      totalPotentialVehicles: $totalPotentialVehicles
      planType: $planType
      videoTelematicsType: $videoTelematicsType
      serviceType: $serviceType
      clientCategory: $clientCategory
      stateManager: $stateManager
      territoryManager: $territoryManager
      salesHead: $salesHead
      clusterHead: $clusterHead
      stateHead: $stateHead
      cityManager: $cityManager
      operationsManager: $operationsManager
      actionDashboardCategory: $actionDashboardCategory
    )
  }
`

const GET_ALL_PLANS = gql`
  query getAllPlans($partnerLoginId: Int!) {
    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {
      id
      planName
    }
  }
`
const GET_ALL_SOLUTION_TYPE_MASTER = gql`
  query GetAllMasterSolutionType {
    getAllMasterSolutionType {
      id
      solutionTypeName
    }
  }
`

const GET_COUNTRIES = gql`
  query {
    allCountries {
      country_id
      name
    }
  }
`

const GET_STATES_FOR_COUNTRY = gql`
  query getStatesByCountryId($countryId: Int!) {
    allStatesByCountryId(country_id: $countryId) {
      name
      zone_id
    }
  }
`
// username validation
const GET_USERNAME = gql`
  query checkUsername($username: String!) {
    checkUsername(username: $username)
  }
`

// Business name validation
const GET_CLIENT_NAME = gql`
  query checkClientName($clientName: String!) {
    checkClientName(clientName: $clientName)
  }
`

// Business name validation
const GET_CONTACTNO = gql`
  query checkClientContactNumber($contactNumber: String!) {
    checkClientContactNumber(contactNumber: $contactNumber)
  }
`

// Business email validation
const GET_EMAIL = gql`
  query checkClientEmail($email: String!) {
    checkClientEmail(email: $email)
  }
`

// Business pan validation
const GET_PAN_NUMBER = gql`
  query checkClientPanNumber($pan: String!) {
    checkClientPanNumber(panNumber: $pan)
  }
` // Business gst validation
const GET_GST_NUMBER = gql`
  query checkClientGST($gst: String!) {
    checkClientGST(GST: $gst)
  }
`

const GET_ALL_SALESPERSON = gql`
  query getAllSalesPerson($partnerLoginId: Int) {
    getAllSalesPerson(partnerLoginId: $partnerLoginId) {
      id
      name
    }
  }
`
const GET_GST_INFO = gql`
  query getGstDetails($gstNumber: String!) {
    getGstDetails(gstNumber: $gstNumber) {
      status
      panNumber
      companyName
      address
      pinCode
    }
  }
`
const GET_ZM_KAM_SM_CSM_DETAILS = gql`
  query GetAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(roleName: $roleName) {
      id
      role
      username
    }
  }
`

const GET_STATE_DETAILS_BY_PINCODE = gql`
  query GetStateDetailsByPincode($pincode: String) {
    getStateDetailsByPincode(pincode: $pincode) {
      pincode
      taluk
      districtname
      statename
    }
  }
`

const GET_SAP_DETAILS = gql`
  query GetSapDetails($directCustomerSapCode: String) {
    getSapDetails(directCustomerSAPCode: $directCustomerSapCode) {
      customer_name
      pan_number
      email_address
      gstin_number
      payment_term
      posting_blk
      city
      street5
      customer_no
      cust_group3
      cust_group4
      distribution_channel
      street_house_number
      street2
      district
      street3
      town
      street4
      shipping_plant1
      shipping_plant2
      customer_group1
      postal_code
      region_descr
      lst_number
      tax_code
      bank_key
      tax_description
      sales_office
      sales_group
      sales_dist
      sales_dist_desc
      phone_number1
      phone_number2
      customer_group
      dealer_type
      appointment_date
      reappointment_date
      conversion_date
      credit_ctrl_area
      itr_compliance
      risk_category
      pan_aadhar_link
      recovery_status
      club_type
      club_type_desc
      region_code
      order_blk
      billing_blk
      delivery_blk
      payment_blk
      attribute1
      attribute2
      route_plan
      route_plan_desc
      tcs_jtc1
      sales_organization
      reconciliation_account
      attribute4
      owner_name
      owner_address
      parent_customer
      parent_customer_name
      customer_plant
      valid_resale_certificate
      certificate_type
      certificate_number
      certificate_valid_from
      certificate_valid_to
      vat_registration_number
    }
  }
`

const GET_CHANNEL_PARTNER_DETAILS = gql`
  query getChannelPartnerDetails($id: ID) {
    getChannelPartnerDetails(id: $id) {
      id
      channel_partner_name
      channel_partner_type
      channel_partner_sap_code
    }
  }
`

const GET_DROPDOWN_DETAILS = gql`
  query Query {
    getDropDownDetail
  }
`

const roleNames = [
  'Key Account Manager(KAM)',
  'Service Manager',
  'State Manager(SM)',
  'Sales Head',
  'Cluster Head',
  'State Head',
  'City Manager',
  'Territory Manager',
  'Operations Manager',
  'Customer Success Manager',
  'Zonal Manager(ZM)'
]

const SOLUTION_TYPES = [
  {
    value: 'API',
    label: 'API'
  },
  {
    value: 'PORTAL',
    label: 'PORTAL'
  }
]

const TYPE_OF_CLIENT = [
  {
    value: 'REAL',
    label: 'COMMERCIAL'
  },
  {
    value: 'DEMO',
    label: 'NON-COMMERCIAL'
  }
]

// const CUSTOMER_TYPES = [
//   {
//     value: 'International',
//     label: 'International'
//   },
//   {
//     value: 'Registered',
//     label: 'Registered'
//   },
//   {
//     value: 'Unregistered',
//     label: 'Unregistered'
//   }
// ]

const CUSTOMER_TYPES = [
  {
    value: 'Paid',
    label: 'Paid'
  },
  {
    value: 'POC',
    label: 'POC'
  },
  {
    value: 'R&D',
    label: 'R&D'
  },
  {
    value: 'Demo',
    label: 'Demo'
  },
  {
    value: 'Closed',
    label: 'Closed'
  }
]

const CUSTOMER_ACQUISITION_TYPES = [
  {
    value: 'Direct Customer',
    label: 'Direct Customer'
  },
  {
    value: 'Indirect Customer',
    label: 'Indirect Customer'
  }
]

const DIRECT_CUSTOMER_TYPE_OPTIONS = [
  {
    value: 'Fleet',
    label: 'Fleet'
  },
  {
    value: 'Mining Customer',
    label: 'Mining Customer'
  },
  {
    value: 'Construction Customer',
    label: 'Construction Customer'
  },
  {
    value: 'Enterprise Customer',
    label: 'Enterprise Customer'
  }
]

const INDIRECT_CUSTOMER_TYPE_OPTIONS = [
  {
    value: 'System Integrator',
    label: 'System Integrator'
  },
  {
    value: 'Telematics Dealer',
    label: 'Telematics Dealer'
  },
  {
    value: 'Non Tyre Dealer',
    label: 'Non Tyre Dealer'
  },
  {
    value: 'CEAT Tyre Dealer',
    label: 'CEAT Tyre Dealer'
  },
  {
    value: 'Non CEAT Tyre Dealer',
    label: 'Non CEAT Tyre Dealer'
  },
  {
    value: 'Agent',
    label: 'Agent'
  }
]

const ZM_OPTIONS = []

const KAM_OPTIONS = []

const CHANNEL_PARTNER_OPTIONS = []

const ZONE_OPTIONS = [
  {
    value: 'North',
    label: 'North'
  },
  {
    value: 'South',
    label: 'South'
  },
  {
    value: 'Central/East',
    label: 'Central/East'
  },
  {
    value: 'West',
    label: 'West'
  }
]

const CUSTOMER_SUCCESS_MANAGER_OPTIONS = []

const SERVICE_MANAGER_OPTIONS = []

const CUSTOMER_LOCATIONS = [
  {
    value: 'India',
    label: 'India'
  },
  {
    value: 'International',
    label: 'International'
  }
]

// const BILLING_MODES = [
//   {
//     value: 1,
//     label: 'PREPAID'
//   },
//   {
//     value: 2,
//     label: 'POSTPAID'
//   }
// ]

const PORTAL_MODES = [
  { label: 'Taabi Pro', value: 'taabi_pro' },
  { label: 'Taabi GPS Lite', value: 'taabi_gps_lite' }
]

// const VIDEO_TELEMATICS_TYPE = [
//   { label: "LightMetrics", value: "lightMetrics" },
//   { label: "LocoNav", value: "loconav" },
//   { label: "MettaX", value: "mettax" }
// ]

const VIDEO_TELEMATICS_TYPE = [
  { label: 'None', value: 'none' },
  { label: 'iFrame-LM', value: 'iframe_lm' },
  { label: 'API-Meta', value: 'api_meta' },
  { label: 'API-Loconav', value: 'api_loconav' }
]

const SERVICE_TYPES = [
  { label: 'Portal', value: 'portal' },
  { label: 'API', value: 'api' }
]

class RegisterCustomer extends Component {
  constructor(props) {
    super(props)
    let timezoneLists = require('timezone-list').getTimezones()

    const timezoneList = timezoneLists.map(timezone => ({
      value: timezone,
      label: timezone
    }))

    this.state = {
      clientName: '',
      username: '',
      contactPerson: '',
      isSecondaryContact: false,
      secondaryContactName: '',
      password: '',
      email: '',
      secondaryEmail: '',
      contactNumber: '',
      landlineNumber: '',
      secondaryContactNumber: '',
      secondaryLandlineNumber: '',
      address: '',
      // address2: '',
      shippingAddress: '',
      // shippingAddress2: '',

      shippingPincode: '',

      city: '',
      shippingCity: '',
      state: '',
      stateId: '',
      country: 99,
      shippingCountry: '',
      shippingState: '',
      pincode: '',
      pan: '',
      gst: '',
      isGstInfoAvailable: true,
      panNumber: '',
      gstCompanyName: '',
      planId: '',
      planType: '',
      timezoneList: timezoneList,
      timezone: { value: 'Asia/Kolkata', label: 'Asia/Kolkata' },
      isEmailValid1: true,
      isEmailValid2: true,
      isPhonenoValid1: true,
      isPhonenoValid2: true,
      isLandlineNumberValid: true,
      isSecondaryLandlineNumberValid: true,
      isAddressValid: true,
      isShippingAddressValid: true,
      isCityValid: true,
      isShippingCityValid: true,
      isPinValid: true,
      isPanValid: true,
      isGSTValid: true,
      isUsernameValid: true,
      isNameValid: true,
      isContactpValid1: true,
      isContactpValid2: true,
      isPasswordValid: true,
      isUsernameUnique: true,
      isCancelConfDialogOpen: false,
      isSaveConfDialogOpen: false,
      response: false,
      clientNameRes: '',
      isEmailExists: 'false',
      isPhoneExists: 'false',
      isPanExists: 'false',
      isGSTExists: null,
      emailRes2: '',
      phonenoRes1: '',
      phonenoRes2: '',
      landlineNumberError: '',
      secondaryLandlineNumberError: '',
      usernameRes: '',
      panNoRes: '',
      typeOfClient: 'REAL',
      // registrationType: 'International',
      registrationType: '',
      customerType: '',
      customerAcquisitionType: '',
      directCustomer: '',
      directCustomerType: '',
      directCustomerSAPCode: '',
      indirectCustomerType: '',
      channelPartnerType: '',
      indirectCustomerName: '',
      customerLocation: { label: 'India', value: 'India' },
      customerAddress: '',
      isChecked: false,
      shipping: false,
      expiryDateTime: moment().add(1, 'week'),
      solution: '',
      billingMode: '',
      salesPerson: 0,
      minimumTrackedDays: 0,
      packetThreshold: 0,
      prorata: 0,
      addressEffectiveDate: null,
      allSalesPerson: [],
      shippingmode: false,
      is_sim_tracking: false,
      isShippingPinvalid: true,
      gstErrorFieldText: '',
      showFields: false,
      selectedMode: { label: 'Taabi Pro', value: 'taabi_pro' },
      selectedZM: '',
      selectedSM: '',
      selectedKAM: '',
      selectedStateManager: '',
      selectedTerritoryManager: '',
      selectedSalesHead: '',
      selectedClusterHead: '',
      selectedStateHead: '',
      selectedCityManager: '',
      selectedOperationsManager: '',
      zone: '',
      serviceManager: '',
      customerSuccessManager: '',
      selectedPlan: '',
      zonalManagers: [],
      stateManagers: [],
      territoryManagers: [],
      salesHeads: [],
      clusterHeads: [],
      stateHeads: [],
      cityManagers: [],
      operationsManagers: [],
      keyAccountManagers: [],
      serviceManagers: [],
      customerSuccessManagers: [],
      // selectedSolutionMaster: '',
      // selectedVTM:{ label: "None", value: "none" },
      selectedVTM: 'none',
      selectedServiceType: 'portal',
      channelPartnerName: '',
      channelPartnerSAPCode: '',
      customerNameToBeDisplayed: '',
      totalPotentialVehicles: '',
      clientCategory: 'B',
      clientCategoryOptions: [
        { value: 'C', label: 'Committed Customer' },
        { value: 'B', label: 'Basic Customer' }
      ],
      actionDashboardType: '',
      actionDashboardTypeOptions: [
        { value: 'POC', label: 'POC' },
        { value: 'Priority Customer', label: 'Priority Customer' },
        { value: 'Control Tower (CT)', label: 'Control Tower (CT)' }
      ],
      isAdditionalContact: false,
      additionalContactNumbers: '',
      isAdditionalContactValid: true,
      additionalContactError: ''
    }
  }

  // fetchDropdownData = async (type, countryId = null) => {
  //   if (type === 'countries') {
  //     this.setState({ allCountries: [] });
  //   } else if (type === 'states') {
  //     this.setState({ allStatesByCountryId: [] });
  //   }

  //   try {
  //     let query;
  //     let variables;

  //     if (type === 'countries') {
  //       query = GET_COUNTRIES;
  //     } else if (type === 'states' && countryId) {
  //       query = GET_STATES_FOR_COUNTRY;
  //       variables = { countryId };
  //     } else {
  //       throw new Error("Invalid parameters: type must be 'countries' or 'states' with a valid countryId.");
  //     }

  //     const { data } = await this.props.client.query({
  //       query,
  //       variables,
  //     });

  //     if (type === 'countries') {
  //       const { allCountries } = data;
  //       this.setState({
  //         countries: allCountries.map(country => ({
  //           value: country.country_id,
  //           label: country.name,
  //         })),
  //       });
  //     } else if (type === 'states') {
  //       const { allStatesByCountryId } = data;
  //       this.setState({
  //         states: allStatesByCountryId.map(state => ({
  //           value: state.zone_id,
  //           label: state.name,
  //         })),
  //       });
  //     }
  //   } catch (error) {
  //     console.error(`Error fetching ${type}:`, error);
  //   }
  // };

  fetchDropdownDetails = async () => {
    try {
      const response = await this.props.client.query({
        query: GET_DROPDOWN_DETAILS
      })

      console.log('Raw response:', response)

      const dropDownData = JSON.parse(response.data.getDropDownDetail)

      console.log('Parsed dropdown data:', dropDownData)

      const dropdownValues = {}

      Object.keys(dropDownData).forEach(key => {
        if (Array.isArray(dropDownData[key])) {
          dropdownValues[key] = dropDownData[key].filter(
            option => option !== null
          )
        }
      })

      this.setState({
        ...dropdownValues
      })
    } catch (error) {
      console.error('Error fetching dropdown details:', error)
    }
  }

  componentDidMount = () => {
    this.getAllSalesPersonDetails()
    this.fetchDropdownDetails()
    this.getChannelPartnerDetailsNew()
    this.getZmKamSmCsmDetails()
  }

  getZmKamSmCsmDetails = async () => {
    this.props.client
      .query({
        query: GET_ZM_KAM_SM_CSM_DETAILS,
        variables: { roleName: roleNames },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        const { data } = response

        if (data && data.getAdminUserDetailsByRole) {
          const zonalManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Zonal Manager(ZM)')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const stateManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'State Manager(SM)')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const territoryManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Territory Manager')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const salesHeads = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Sales Head')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const clusterHeads = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Cluster Head')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const stateHeads = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'State Head')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const cityManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'City Manager')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const operationsManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Operations Manager')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const keyAccountManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Key Account Manager(KAM)')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const serviceManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Service Manager')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          const customerSuccessManagers = data.getAdminUserDetailsByRole
            .filter(user => user.role === 'Customer Success Manager')
            .map(user => ({
              id: user.id,
              value: user.id,
              label: user.username
            }))

          this.setState({
            zonalManagers,
            stateManagers,
            territoryManagers,
            salesHeads,
            clusterHeads,
            stateHeads,
            cityManagers,
            operationsManagers,
            keyAccountManagers,
            serviceManagers,
            customerSuccessManagers
          })
        }
      })
      .catch(error => {
        console.error('Error fetching ZM, KAM, SM, CSM details:', error)
      })
  }

  handleInputChange = key => e => {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }
  handleInputChangeIndirectCustomerName = key => e => {
    const { name, value } = e.target
    this.setState({ [name]: value, customerNameToBeDisplayed: value })
  }

  handleInputChangeUsernamePassword = e => {
    let regExValue = new RegExp(/^[0-9a-zA-Z]+$/)

    // const { value } = e.target

    // console.log('input value', value)

    // console.log(this.state.country)

    this.setState({ [e.target.name]: e.target.value })
  }

  handleCheckboxChange = e => {
    const name = e.target.name

    this.setState(prev => ({
      isChecked: !prev.isChecked
    }))
  }

  handleToggle = () => {
    this.setState(prevState => ({
      showFields: !prevState.showFields
    }))
  }

  handleModeChange = selectedOption => {
    this.setState({ selectedMode: selectedOption })
  }
  handleVideoTelematicsMenuChange = selectedOption => {
    this.setState({ selectedVTM: selectedOption ? selectedOption.value : '' })
  }
  handleServiceTypeChange = selectedOption => {
    this.setState({
      selectedServiceType: selectedOption ? selectedOption.value : ''
    })
  }
  handleZMChange = selectedOption => {
    this.setState({ selectedZM: selectedOption })
  }
  handleSMChange = selectedOption => {
    this.setState({ selectedSM: selectedOption })
  }

  handleKAMChange = selectedOption => {
    this.setState({ selectedKAM: selectedOption })
  }

  handleStateManagerChange = selectedOption => {
    this.setState({ selectedStateManager: selectedOption })
  }

  handleTerritoryManagerChange = selectedOption => {
    this.setState({ selectedTerritoryManager: selectedOption })
  }

  handleSalesHeadChange = selectedOption => {
    this.setState({ selectedSalesHead: selectedOption })
  }

  handleClusterHeadChange = selectedOption => {
    this.setState({ selectedClusterHead: selectedOption })
  }

  handleStateHeadChange = selectedOption => {
    this.setState({ selectedStateHead: selectedOption })
  }

  handleCityManagerChange = selectedOption => {
    this.setState({ selectedCityManager: selectedOption })
  }

  handleOperationsManagerChange = selectedOption => {
    this.setState({ selectedOperationsManager: selectedOption })
  }

  handleZoneChange = selectedOption => {
    this.setState({ zone: selectedOption })
  }

  handleServiceManagerChange = selectedOption => {
    this.setState({ serviceManager: selectedOption })
  }

  handleCustomerSuccessManagerChange = selectedOption => {
    this.setState({ customerSuccessManager: selectedOption })
  }

  handleChannelPartnerNameChange = event => {
    this.setState({ channelPartnerName: event.target.value })
  }

  handleProrataCheckboxChange = e => {
    this.state.prorata
      ? this.setState({ prorata: 0 })
      : this.setState({ prorata: 1 })
  }
  setProrata = e => {
    this.setState({ minimumTrackedDays: 1, packetThreshold: 1 })
  }

  handleShipping = e => {
    this.state.shippingmode
      ? this.setState({ shippingmode: false })
      : this.setState({ shippingmode: true })
    // this.setState(prev => ({ shipping: !prev.shipping }))

    this.state.shippingmode
      ? this.setState({ shippingCountry: '' })
      : this.setState({ shippingCountry: this.state.country })
    this.state.shippingmode
      ? this.setState({ shippingState: '' })
      : this.setState({ shippingState: this.state.state })

    this.state.shippingmode
      ? this.setState({ shippingAddress: '' })
      : this.setState({ shippingAddress: this.state.address })

    this.state.shippingmode
      ? this.setState({ shippingPincode: '' })
      : this.setState({ shippingPincode: this.state.pincode })

    this.state.shippingmode
      ? this.setState({ shippingCity: '' })
      : this.setState({ shippingCity: this.state.city })
  }

  handleSimTracking = e => {
    this.state.is_sim_tracking
      ? this.setState({ is_sim_tracking: false })
      : this.setState({ is_sim_tracking: true })
  }

  handleProrata = e => {
    this.setState({ [e.target.name]: e.target.value, isStateChanged: true })
  }

  handleSolutionChange = solutionType => {
    // console.log('solution:', solutionType)
    if (!solutionType) {
      this.setState({ solution: '' })
    } else {
      this.setState({ solution: solutionType.value })
    }
  }

  handleCustomerTypeChange = customer => {
    // console.log('Customer', customer)
    if (!customer) {
      this.setState({ customerType: '' })
    } else {
      this.setState({
        customerType: customer.value,
        isGSTExists: null,
        isGSTValid: true,
        gst: '',
        panNumber: '',
        address: '',
        pincode: '',
        gstCompanyName: '',
        clientNameRes: '',
        isNameValid: true,
        isAddressValid: true,
        isPinValid: true
      })
    }
  }

  handleCustomerAcquisitionTypeChange = selectedOption => {
    this.setState({
      customerAcquisitionType: selectedOption ? selectedOption.value : ''
    })

    if (this.state.customerAcquisitionType == 'Direct Customer') {
      this.setState({
        indirectCustomerType: null,
        indirectCustomerName: null,
        channelPartnerName: null,
        channelPartnerSAPCode: null,
        channelPartnerType: null
      })
    } else if (this.state.customerAcquisitionType == 'Indirect Customer') {
      this.setState({
        directCustomerType: null,
        directCustomer: null,
        directCustomerSAPCode: null
      })
    }
  }

  handleClientType = clientType => {
    if (!clientType) {
      this.setState({ typeOfClient: '' })
    } else {
      this.setState({
        typeOfClient: clientType.value
      })
    }
  }

  hanldeBillingModeChange = billingMode => {
    if (!billingMode) {
      this.setState({ billingMode: '' })
    } else {
      this.setState({ billingMode: billingMode.value })
    }
  }

  getAllSalesPersonDetails = async () => {
    const fetchSalesPersonData = await this.props.client.query({
      query: GET_ALL_SALESPERSON,
      variables: {
        partnerLoginId: getLoginId()
      }
    })
    const {
      data: { getAllSalesPerson }
    } = fetchSalesPersonData
    const salesPersonsDetails = getAllSalesPerson.map(salesPerson => ({
      value: salesPerson.id,
      label: salesPerson.name
    }))
    this.setState({ allSalesPerson: salesPersonsDetails })
  }

  handleSalesPersonChange = salesPerson => {
    // console.log('salesPerson', salesPerson)
    if (!salesPerson) {
      this.setState({ salesPerson: '' })
    } else {
      this.setState({ salesPerson: salesPerson.value })
    }
  }

  handleDateTimeChange = date => this.setState({ expiryDateTime: date })

  handleCountryChange = c => {
    if (!c) {
      this.setState({ country: '' })
    } else {
      this.setState({ country: c.value })
      this.state.shipping && this.setState({ shippingCountry: c.value })
    }
  }
  handleSecondaryCountryChange = c => {
    if (!c) {
      this.setState({ shippingCountry: '' })
    } else {
      this.setState({ shippingCountry: c.value })
    }
  }

  handlePlanChange = selectedOption => {
    this.setState({
      selectedPlan: selectedOption,
      planId: selectedOption ? selectedOption.value : null
    })
  }

  // handleSolutionMasterChange = selectedOption => {
  //   console.log("selectedOption",selectedOption)
  //   this.setState({
  //     // isStateChanged: true,
  //     selectedSolutionMaster: selectedOption
  //   });
  // };

  handleTimezoneChange = timezone => {
    if (!timezone) {
      this.setState({ timezone: '' })
    } else {
      this.setState({ timezone })
    }
  }

  handleStateChange = state => {
    this.setState({ state: state })
  }
  handleStateChangeTwo = state => {
    this.setState({ shippingState: state })
  }

  // checkNameValidity = client => async event => {
  //   const regex = new RegExp(
  //     /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
  //   )
  //   const { data } = await client.query({
  //     query: GET_CLIENT_NAME,
  //     variables: { clientName: this.state.clientName }
  //   })

  //   this.setState({
  //     isNameValid:
  //       regex.test(this.state.name) &&
  //       this.state.name !== '' &&
  //       data.checkClientName === 'AVAILABLE'
  //   })

  //   if (this.state.name.length === 0) {
  //     this.setState({
  //       clientNameRes: 'Please enter the name'
  //     })
  //   } else if (
  //     this.state.name.length !== 0 &&
  //     regex.test(this.state.name) === false
  //   ) {
  //     this.setState({
  //       clientNameRes:
  //         'Name can be characters or Number between 5-32 characters'
  //     })
  //   } else if (data.checkClientName !== 'AVAILABLE') {
  //     // console.log('availabe')
  //     this.setState({ clientNameRes: 'Name already exist' })
  //   }
  // }

  checkNameValidity = client => async event => {
    console.log('inside checkName')
    const { customerNameToBeDisplayed } = this.state

    const regex = new RegExp(
      // /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
      /^(?!\s)(?!.*\s$).{5,100}$/
    )

    const isValidFormat =
      regex.test(
        this.state.customerAcquisitionType === 'Direct Customer'
          ? this.state.customerNameToBeDisplayed ||
            (this.state.directCustomer ? this.state.directCustomer.label : '')
          : this.state.customerAcquisitionType === 'Indirect Customer'
            ? this.state.customerNameToBeDisplayed ||
              this.state.indirectCustomerName
            : this.state.customerNameToBeDisplayed || ''
      ) &&
      (this.state.customerAcquisitionType === 'Direct Customer'
        ? this.state.customerNameToBeDisplayed ||
          (this.state.directCustomer ? this.state.directCustomer.label : '')
        : this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.customerNameToBeDisplayed ||
            this.state.indirectCustomerName
          : this.state.customerNameToBeDisplayed || '') !== ''

    let isNameAvailable = false
    console.log('isNameAvailable: ', isNameAvailable)
    try {
      const { data } = await client.query({
        query: GET_CLIENT_NAME,
        variables: {
          clientName:
            this.state.customerAcquisitionType === 'Direct Customer'
              ? this.state.customerNameToBeDisplayed ||
                (this.state.directCustomer
                  ? this.state.directCustomer.label
                  : '')
              : this.state.customerAcquisitionType === 'Indirect Customer'
                ? this.state.customerNameToBeDisplayed ||
                  this.state.indirectCustomerName
                : this.state.customerNameToBeDisplayed || ''
        }
      })

      isNameAvailable = data.checkClientName === 'AVAILABLE'
    } catch (error) {
      console.error('Error checking name availability', error)
      isNameAvailable = false
    }
    console.log('isNameAvailable after checking: ', isNameAvailable)

    console.log(
      'isValidFormat && isNameAvailable :',
      isValidFormat && isNameAvailable
    )

    this.setState({
      isNameValid: isValidFormat && isNameAvailable,
      clientNameRes:
        (this.state.customerAcquisitionType === 'Direct Customer'
          ? this.state.customerNameToBeDisplayed ||
            (this.state.directCustomer ? this.state.directCustomer.label : '')
          : this.state.customerAcquisitionType === 'Indirect Customer'
            ? this.state.customerNameToBeDisplayed ||
              this.state.indirectCustomerName
            : this.state.customerNameToBeDisplayed || ''
        ).length === 0
          ? 'Please enter the name'
          : !isValidFormat
            ? 'Name must be at least 5 characters long and not contain spaces at beginning or end'
            : !isNameAvailable
              ? 'Name already exists'
              : ''
    })
  }

  checkUsernameValidity = client => async event => {
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/)
    const { data } = await client.query({
      query: GET_USERNAME,
      variables: { username: this.state.username }
    })

    this.setState({
      isUsernameUnique: data.checkUsername === 'AVAILABLE',
      isUsernameValid:
        regex.test(this.state.username) &&
        this.state.username !== '' &&
        data.checkUsername === 'AVAILABLE'
    })

    if (regex.test(this.state.username) === false) {
      this.setState({
        usernameRes:
          'Username Can be character number special chatcters(-_$@*!) without blank space between 5-32 charcters',
        isUsernameValid: false
      })
    } else if (data.checkUsername !== 'AVAILABLE') {
      this.setState({
        usernameRes: 'Username already exist',
        isUsernameValid: false
      })
    }
  }

  checkContactpValidity = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)

    this.setState({
      isContactpValid1: regex.test(this.state.contactPerson)
    })
  }

  checkContactpValidityTwo = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)

    this.setState({
      isContactpValid2: regex.test(this.state.secondaryContactName)
    })
  }

  checkPasswordValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!#]{3,20}$/)
    const regex = new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/"]{3,20}$/)
    this.setState({
      isPasswordValid:
        this.state.password !== '' && regex.test(this.state.password)
    })
  }

  checkPhonenoValidity1 = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)
    const { data } = await client.query({
      query: GET_CONTACTNO,
      variables: { contactNumber: this.state.contactNumber }
    })

    this.setState({
      isPhoneExists: data.checkClientContactNumber === 'AVAILABLE',
      isPhonenoValid1: regex.test(this.state.contactNumber)
    })
    if (this.state.contactNumber === this.state.secondaryContactNumber) {
      this.setState({
        phonenoRes2:
          'Secondary Contact Number should not be the same as Primary Contact Number',
        isPhonenoValid2: false
      })
    }
  }

  checkPhonenoValidity2 = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)

    if (this.state.secondaryContactNumber !== '') {
      this.setState({
        isPhonenoValid2: regex.test(this.state.secondaryContactNumber)
      })

      if (regex.test(this.state.secondaryContactNumber) === false) {
        this.setState({ phonenoRes2: 'Invalid phone number' })
      }

      if (this.state.secondaryContactNumber === this.state.contactNumber) {
        this.setState({
          phonenoRes2:
            'Secondary Contact Number should not be the same as Primary Contact Number',
          isPhonenoValid2: false
        })
      }
    } else {
      this.setState({
        phonenoRes2: 'Invalid phone number',
        isPhonenoValid2: false
      })
    }
  }

  checkLandlineValidity = async (event, fieldName) => {
    const regex = new RegExp(/^\(?\d{3,4}\)?[-\s]?\d{6,8}$/)

    const landlineNumber = this.state[fieldName]

    if (landlineNumber !== '') {
      const isValid = regex.test(landlineNumber)
      this.setState({
        [`${fieldName}Valid`]: isValid
      })

      if (!isValid) {
        this.setState({ [`${fieldName}Error`]: 'Invalid landline number' })
      } else {
        this.setState({ [`${fieldName}Error`]: '' })
      }
    }
  }

  checkEmailValidity1 = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    const { data } = await client.query({
      query: GET_EMAIL,
      variables: { email: this.state.email }
    })
    this.setState({
      isEmailExists: data.checkClientEmail === 'AVAILABLE',
      isEmailValid1: regex.test(this.state.email)
    })
    if (this.state.email === this.state.secondaryEmail) {
      this.setState({
        emailRes2: 'Secondary Email should not be the same as Primary Email',
        isEmailValid2: false
      })
    }
  }

  checkEmailValidity2 = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    if (this.state.secondaryEmail !== '') {
      this.setState({
        isEmailValid2: regex.test(this.state.secondaryEmail)
      })
      if (regex.test(this.state.secondaryEmail) === false) {
        this.setState({ emailRes2: 'Invalid Email' })
      }

      if (this.state.secondaryEmail === this.state.email) {
        this.setState({
          emailRes2: 'Secondary Email should not be the same as Primary Email',
          isEmailValid2: false
        })
      }
    } else {
      this.setState({
        emailRes2: 'Invalid email',
        isEmailValid2: false
      })
    }
  }
  checkAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)

    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) && regex2.test(this.state.address)
    })
  }

  checkShippingAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)

    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isShippingAddressValid:
        regex.test(this.state.shippingAddress) &&
        regex2.test(this.state.shippingAddress)
    })
  }

  checkCountryValidity = () => {
    this.setState({
      isCountryValid: this.state.country !== ''
    })
  }

  checkCountryValidity2 = () => {
    this.setState({
      isCountryValid: this.state.shippingCountry !== ''
    })
  }

  checkCityValidity = arg => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)

    if (arg === 'billing') {
      this.setState({
        isCityValid: regex.test(this.state.city) && this.state.city !== ''
      })
    } else if (arg === 'shipping') {
      this.setState({
        isShippingCityValid:
          regex.test(this.state.shippingCity) && this.state.city !== ''
      })
    }
  }

  checkPinValidity = () => {
    this.setState({ isPinValid: true })
    if (this.state.pincode !== null && this.state.pincode !== '') {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isPinValid: regex.test(this.state.pincode)
      })
    }
  }
  checkPinValidity2 = () => {
    this.setState({ isShippingPinvalid: true })
    if (
      this.state.shippingPincode !== null &&
      this.state.shippingPincode !== ''
    ) {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isShippingPinvalid: regex.test(this.state.shippingPincode)
      })
    }
  }

  checkPanValidity = client => async event => {
    // console.log(this.state.pan, 'pan')
    this.setState({ panNoRes: '' })
    if (this.state.pan !== null && this.state.pan !== '') {
      const regex = new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/)
      const { data } = await client.query({
        query: GET_PAN_NUMBER,
        variables: { pan: this.state.pan }
      })

      this.setState({
        isPanValid: regex.test(this.state.pan),
        isPanExists: data.checkClientPanNumber === 'AVAILABLE'
      })
    }
  }

  checkGSTValidity = async gstNumber => {
    if (this.state.gst !== null && this.state.gst !== '') {
      // const regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[a-zA-Z0-9]{1}$/)
      const regex = new RegExp(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
      )
      const { data } = await this.props.client.query({
        query: GET_GST_NUMBER,
        variables: { gst: this.state.gst },
        fetchPolicy: 'network-only'
      })

      this.setState({
        isGSTExists: data.checkClientGST === 'AVAILABLE',
        isGSTValid: regex.test(this.state.gst)
      })

      if (!this.state.isGSTValid) {
        this.setState({
          gstErrorFieldText: 'Invalid GST Number.'
        })
      }

      if (this.state.isGSTExists == false) {
        this.setState({ gstErrorFieldText: 'GST Number already registered.' })
      }

      if (this.state.isGSTValid && this.state.isGSTExists) {
        this.setState({
          gstErrorFieldText: '',
          panNumber: '',
          gstCompanyName: '',
          address: '',
          pincode: ''
        })

        await this.getGstInfo(gstNumber)
        if (!this.state.isGstInfoAvailable) {
          this.setState({ gstErrorFieldText: 'Invalid GST Number.' })
        }
      } else {
        this.setState({
          panNumber: '',
          gstCompanyName: '',
          address: '',
          pincode: ''
        })
      }
    } else {
      this.setState({
        panNumber: '',
        gstCompanyName: '',
        address: '',
        pincode: ''
      })
    }
  }

  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleBackCancelClick = e => {
    if (
      // this.state.name === '' &&
      this.state.username === '' &&
      this.state.clientName === '' &&
      this.state.contactPerson === '' &&
      this.state.secondaryContactName === '' &&
      this.state.password === '' &&
      this.state.email === '' &&
      this.state.secondaryEmail === '' &&
      this.state.contactNumber === '' &&
      this.state.landlineNumber === '' &&
      this.state.secondaryContactNumber === '' &&
      this.state.secondaryLandlineNumber === '' &&
      this.state.address === '' &&
      // this.state.address2 === '' &&
      this.state.shippingAddress === '' &&
      this.state.shippingAddress2 === '' &&
      this.state.shippingCity == '' &&
      this.shippingCountry == '' &&
      this.shippingState == '' &&
      this.state.shippingPincode == '' &&
      this.state.city === '' &&
      this.state.state === '' &&
      this.state.country === '' &&
      this.state.countryTwo === '' &&
      this.state.plan === '' &&
      this.state.timezone === '' &&
      this.state.solution === '' &&
      this.state.pincode === '' &&
      this.state.pan === '' &&
      this.state.gst === '' &&
      this.state.minimumTrackedDays === '' &&
      this.state.prorata === '' &&
      this.state.addressEffectiveDate == ''
    ) {
      this.cancelForm()
    } else {
      this.setState({ isCancelConfDialogOpen: true })
    }
  }

  handleSaveClick = async e => {
    const response = await this.props.client.mutate({
      mutation: ADD_CLIENTS,
      // variables:{

      // },
      errorPolicy: 'all',
      refetchQueries: ['allClientDetails']
    })

    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }

  handleSecondaryContactAvailable = e => {
    this.state.isSecondaryContact
      ? this.setState({
          isSecondaryContact: false,
          isAdditionalContact: false,
          additionalContactNumbers: '',
          isAdditionalContactValid: true,
          additionalContactError: ''
        })
      : this.setState({ isSecondaryContact: true })
  }

  handleAdditionalContactAvailable = () => {
    this.setState(prev => ({ isAdditionalContact: !prev.isAdditionalContact }))
  }

  handleAdditionalContactChange = e => {
    const value = e.target.value
    this.setState({
      additionalContactNumbers: value,
      isAdditionalContactValid: true,
      additionalContactError: ''
    })
  }

  checkAdditionalContactValidity = () => {
    const {
      additionalContactNumbers,
      contactNumber,
      secondaryContactNumber
    } = this.state
    if (!additionalContactNumbers.trim()) {
      this.setState({
        isAdditionalContactValid: true,
        additionalContactError: ''
      })
      return
    }

    const numbers = additionalContactNumbers.split(',').map(num => num.trim())
    const regex = /^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/

    // Check for invalid format
    const invalidNumbers = numbers.filter(num => !regex.test(num))
    if (invalidNumbers.length > 0) {
      this.setState({
        isAdditionalContactValid: false,
        additionalContactError: `Invalid phone number(s): ${invalidNumbers.join(
          ', '
        )}`
      })
      return
    }

    // Check for duplicates with primary or secondary numbers
    const primaryNumber = contactNumber.replace(/[^0-9]/g, '')
    const secondaryNumber = secondaryContactNumber
      ? secondaryContactNumber.replace(/[^0-9]/g, '')
      : ''

    const duplicateNumbers = numbers.filter(num => {
      const cleanNum = num.replace(/[^0-9]/g, '')
      return cleanNum === primaryNumber || cleanNum === secondaryNumber
    })

    if (duplicateNumbers.length > 0) {
      this.setState({
        isAdditionalContactValid: false,
        additionalContactError: `Cannot use primary/secondary number: ${duplicateNumbers.join(
          ', '
        )}`
      })
    } else {
      this.setState({
        isAdditionalContactValid: true,
        additionalContactError: ''
      })
    }
  }

  submitForm = async e => {
    let variables
    e.preventDefault()
    // const planId = this.state.plan
    // const kmZamorChannelPartner = {}
    // if(this.state.channelPartnerName && this.state.showFields){
    //   kmZamorChannelPartner.channelPartnerName=this.state.channelPartnerName,
    //   kmZamorChannelPartner.zonalManager="",
    //   kmZamorChannelPartner.keyAccountManager=""
    // }else{
    //   kmZamorChannelPartner.zonalManager=this.state.selectedZM.value,
    //   kmZamorChannelPartner.keyAccountManager = this.state.selectedKAM.value,
    //   kmZamorChannelPartner.channelPartnerName=""
    // }

    if (this.state.customerType == 'Registered') {
      variables = {
        username: this.state.username,
        password: this.state.password,
        accountType: 'CLT',
        // clientName: this.state.clientName,
        // clientName: this.state.gstCompanyName,
        clientName:
          this.state.customerNameToBeDisplayed ||
          (this.state.customerAcquisitionType == 'Direct Customer' &&
          this.state.directCustomer
            ? this.state.directCustomer.label
            : this.state.customerAcquisitionType == 'Indirect Customer'
              ? this.state.indirectCustomerName
              : null),
        email: this.state.email,
        secondaryEmail: this.state.secondaryEmail,
        contactPerson: this.state.contactPerson,
        secondaryContactName: this.state.secondaryContactName,
        contactNumber: this.state.contactNumber,
        landlineNumber: this.state.landlineNumber,
        secondaryContactNumber: this.state.secondaryContactNumber,
        secondaryLandlineNumber: this.state.secondaryLandlineNumber,
        // address: this.state.address,
        address: this.state.address,
        city: this.state.city,
        state: parseInt(this.state.stateId, 10),
        country:
          this.state.country && this.state.country.value
            ? parseInt(this.state.country.value, 10)
            : 99,
        shippingCountry: parseInt(this.state.shippingCountry, 10),
        shippingState: parseInt(this.state.shippingState.value, 10),
        // countryTwo: parseInt(this.state.countryTwo, 10),
        // pincode: parseInt(this.state.pincode, 10),
        pincode: parseInt(this.state.pincode, 10),
        // panNumber: this.state.pan,
        panNumber: this.state.panNumber,
        // shippingAddress:
        //   this.state.shippingAddress + ' ' + this.state.shippingAddress2,
        shippingAddress: this.state.shippingAddress + ' ',
        shippingCity: this.state.shippingCity,
        shippingPincode: parseInt(this.state.shippingPincode, 10),
        minimumTrackedDays: parseInt(this.state.minimumTrackedDays, 10),
        packetThreshold: parseInt(this.state.packetThreshold, 10),
        prorata: this.state.prorata,
        addressEffectiveDate: this.state.addressEffectiveDate,
        partnerLoginId: getLoginId(),
        clientType: 'Live',
        // subscriptionPlan: 'prepaid',
        // periodicity: 1,
        planId: parseInt(this.state.planId, 10),
        timezone: this.state.timezone
          ? this.state.timezone.value || this.state.timezone
          : '',
        gst: this.state.gst,
        typeOfClient: this.state.typeOfClient,
        registrationType: this.state.customerType,
        customerAcquisitionType: this.state.customerAcquisitionType,
        directCustomer: this.state.directCustomer.label,
        directCustomerType: this.state.directCustomerType,
        directCustomerSAPCode: this.state.directCustomer.value,
        indirectCustomerType: this.state.indirectCustomerType,
        channelPartnerType: this.state.channelPartnerType,
        indirectCustomerName: this.state.indirectCustomerName,
        customerLocation: this.state.customerLocation
          ? this.state.customerLocation.value || this.state.customerLocation
          : '',
        customerAddress: this.state.customerAddress,
        solution: this.state.solution,
        billingMode: parseInt(this.state.billingMode, 10),
        salesPersonId: this.state.salesPerson,
        zonalManager:
          this.state.selectedZM && this.state.selectedZM.value
            ? this.state.selectedZM.value
            : '',
        stateManager:
          this.state.selectedSM && this.state.selectedSM.value
            ? this.state.selectedSM.value
            : '',
        keyAccountManager:
          this.state.selectedKAM && this.state.selectedKAM.value
            ? this.state.selectedKAM.value
            : '',
        territoryManager: this.state.selectedTerritoryManager
          ? this.state.selectedTerritoryManager.value
          : null,
        salesHead: this.state.selectedSalesHead
          ? this.state.selectedSalesHead.value
          : null,
        clusterHead: this.state.selectedClusterHead
          ? this.state.selectedClusterHead.value
          : null,
        stateHead: this.state.selectedStateHead
          ? this.state.selectedStateHead.value
          : null,
        cityManager: this.state.selectedCityManager
          ? this.state.selectedCityManager.value
          : null,
        operationsManager: this.state.selectedOperationsManager
          ? this.state.selectedOperationsManager.value
          : null,
        zone: this.state.zone || '',
        serviceManager: this.state.serviceManager || '',
        customerSuccessManager: this.state.customerSuccessManager || '',
        planType:
          this.state.selectedPlan && this.state.selectedPlan.label
            ? this.state.selectedPlan.label
            : null,
        // solutionId: this.state.selectedSolutionMaster && this.state.selectedSolutionMaster.value ? this.state.selectedSolutionMaster.value : null,
        videoTelematicsType:
          this.state.selectedVTM === 'none' ? null : this.state.selectedVTM,
        serviceType: this.state.selectedServiceType,
        // channelPartnerName: this.state.showFields
        //   ? this.state.channelPartnerName
        //   : null,
        // channelPartnerName: this.state.channelPartnerName,
        channelPartnerName: this.state.channelPartnerName || null,
        channelPartnerSAPCode: this.state.channelPartnerSAPCode || null,
        litemode:
          this.state.selectedMode && this.state.selectedMode.value
            ? convertToSnakeCase(this.state.selectedMode.value)
            : null,
        customerNameToBeDisplayed:
          this.state.customerNameToBeDisplayed ||
          (this.state.customerAcquisitionType == 'Direct Customer' &&
          this.state.directCustomer
            ? this.state.directCustomer.label
            : this.state.customerAcquisitionType == 'Indirect Customer'
              ? this.state.indirectCustomerName
              : null),
        totalPotentialVehicles: parseInt(this.state.totalPotentialVehicles),
        is_sim_tracking: this.state.is_sim_tracking,
        clientCategory: this.state.clientCategory,
        isSecondaryContact: this.state.isSecondaryContact,
        additionalContactNumbers: this.state.additionalContactNumbers,
        actionDashboardCategory:
          this.state.actionDashboardType === 'POC'
            ? '1'
            : this.state.actionDashboardType === 'Priority Customer'
              ? '2'
              : this.state.actionDashboardType === 'Control Tower (CT)'
                ? '3'
                : null
      }
    } else {
      variables = {
        username: this.state.username,
        password: this.state.password,
        accountType: 'CLT',
        // clientName: this.state.clientName,
        clientName: this.state.customerNameToBeDisplayed,
        email: this.state.email,
        secondaryEmail: this.state.secondaryEmail,
        contactPerson: this.state.contactPerson,
        secondaryContactName: this.state.secondaryContactName,
        contactNumber: this.state.contactNumber,
        landlineNumber: this.state.landlineNumber,
        secondaryContactNumber: this.state.secondaryContactNumber,
        secondaryLandlineNumber: this.state.secondaryLandlineNumber,
        // address: this.state.address,
        address: this.state.address,
        city: this.state.city,
        state: parseInt(this.state.stateId, 10),
        country:
          this.state.country && this.state.country.value
            ? parseInt(this.state.country.value, 10)
            : 99,
        shippingCountry: parseInt(this.state.shippingCountry, 10),
        shippingState: parseInt(this.state.shippingState.value, 10),
        // countryTwo: parseInt(this.state.countryTwo, 10),
        // pincode: parseInt(this.state.pincode, 10),
        pincode: parseInt(this.state.pincode, 10),
        // panNumber: this.state.pan,
        // panNumber: this.state.panNumber,
        // shippingAddress:
        //   this.state.shippingAddress + ' ' + this.state.shippingAddress2,
        shippingAddress: this.state.shippingAddress + ' ',
        shippingCity: this.state.shippingCity,
        shippingPincode: parseInt(this.state.shippingPincode, 10),
        minimumTrackedDays: parseInt(this.state.minimumTrackedDays, 10),
        packetThreshold: parseInt(this.state.packetThreshold, 10),
        prorata: this.state.prorata,
        addressEffectiveDate: this.state.addressEffectiveDate,
        partnerLoginId: getLoginId(),
        clientType: 'Live',
        subscriptionPlan: 'prepaid',
        // periodicity: 1,
        planId: parseInt(this.state.planId, 10),
        timezone: this.state.timezone
          ? this.state.timezone.value || this.state.timezone
          : '',
        gst: this.state.gst,
        typeOfClient: this.state.typeOfClient,
        registrationType: this.state.customerType,
        customerAcquisitionType: this.state.customerAcquisitionType,
        directCustomer: this.state.directCustomer
          ? this.state.directCustomer.label
          : null,
        directCustomerType: this.state.directCustomerType,
        directCustomerSAPCode: this.state.directCustomer
          ? this.state.directCustomer.value
          : null,
        indirectCustomerType: this.state.indirectCustomerType,
        channelPartnerType: this.state.channelPartnerType,
        indirectCustomerName: this.state.indirectCustomerName,
        customerLocation: this.state.customerLocation
          ? this.state.customerLocation.value || this.state.customerLocation
          : '',
        customerAddress: this.state.customerAddress,
        solution: this.state.solution,
        billingMode: parseInt(this.state.billingMode, 10),
        salesPersonId: this.state.salesPerson,
        zonalManager:
          this.state.selectedZM && this.state.selectedZM.value
            ? this.state.selectedZM.value
            : '',
        stateManager:
          this.state.selectedSM && this.state.selectedSM.value
            ? this.state.selectedSM.value
            : '',
        keyAccountManager:
          this.state.selectedKAM && this.state.selectedKAM.value
            ? this.state.selectedKAM.value
            : '',
        territoryManager: this.state.selectedTerritoryManager
          ? this.state.selectedTerritoryManager.value
          : null,
        salesHead: this.state.selectedSalesHead
          ? this.state.selectedSalesHead.value
          : null,
        clusterHead: this.state.selectedClusterHead
          ? this.state.selectedClusterHead.value
          : null,
        stateHead: this.state.selectedStateHead
          ? this.state.selectedStateHead.value
          : null,
        cityManager: this.state.selectedCityManager
          ? this.state.selectedCityManager.value
          : null,
        operationsManager: this.state.selectedOperationsManager
          ? this.state.selectedOperationsManager.value
          : null,
        zone: this.state.zone || '',
        serviceManager: this.state.serviceManager || '',
        customerSuccessManager: this.state.customerSuccessManager || '',
        planType:
          this.state.selectedPlan && this.state.selectedPlan.label
            ? this.state.selectedPlan.label
            : null,
        // solutionId: this.state.selectedSolutionMaster && this.state.selectedSolutionMaster.value ? this.state.selectedSolutionMaster.value : null,
        // videoTelematicsType:this.state.selectedVTM && this.state.selectedVTM.value?this.state.selectedVTM.value:null,
        videoTelematicsType:
          this.state.selectedVTM === 'none' ? null : this.state.selectedVTM,
        serviceType: this.state.selectedServiceType,
        channelPartnerName: this.state.channelPartnerName,
        channelPartnerSAPCode: this.state.channelPartnerSAPCode || null,
        litemode:
          this.state.selectedMode && this.state.selectedMode.value
            ? convertToSnakeCase(this.state.selectedMode.value)
            : null,
        customerNameToBeDisplayed: this.state.customerNameToBeDisplayed,
        totalPotentialVehicles: parseInt(this.state.totalPotentialVehicles),
        is_sim_tracking: this.state.is_sim_tracking,
        clientCategory: this.state.clientCategory,
        additionalContactNumbers: this.state.additionalContactNumbers,
        actionDashboardCategory:
          this.state.actionDashboardType === 'POC'
            ? '1'
            : this.state.actionDashboardType === 'Priority Customer'
              ? '2'
              : this.state.actionDashboardType === 'Control Tower (CT)'
                ? '3'
                : null
      }
    }

    // console.log(variables.address)

    variables['is_sim_tracking'] = this.state.is_sim_tracking
    if (this.state.typeOfClient === 'NON-COMMERCIAL') {
      variables['expiryDate'] = moment(this.state.expiryDateTime)
        .unix()
        .toString()
      console.log("variables['expiryDate']", variables['expiryDate'])
    }
    console.log('after if')
    // if (!this.state.selectedPlan) {
    //   this.props.openSnackbar('Select a valid plan')
    // }
    // if (!this.state.selectedSolutionMaster) {
    //   this.props.openSnackbar('Select a valid Solution to Proceed')
    // }
    // else {
    var { data, errors } = await this.props.client.mutate({
      mutation: ADD_CLIENTS,
      variables,
      errorPolicy: 'all',
      refetchQueries: ['allClientDetails']
    })
    console.log(data, errors)
    if (data) {
      axios
        .post('https://n8n-dev.taabi.co/webhook/customer-created', variables)
        .catch(webhookError => {
          console.log('customer-created webhook failed', webhookError)
        })
      await this.props.client.clearStore()
      this.props.openSnackbar('Registered Successfully')
      this.setState({
        id: '',
        clientName: '',
        username: '',
        contactPerson: '',
        secondaryContactName: '',
        password: '',
        email: '',
        secondaryEmail: '',
        contactNumber: '',
        landlineNumber: '',
        secondaryContactNumber: '',
        secondaryLandlineNumber: '',
        address1: '',
        // address2: '',
        shippingAddress: '',
        // shippingAddress2: '',
        channelPartnerSAPCodeNew: [],
        shippingPincode: '',
        minimumTrackedDays: '',
        prorata: '',
        addressEffectiveDate: '',

        city: '',
        shippingCity: '',
        state: '',
        country: 99,
        secondaryCountry: '',
        secondaryState: '',
        pincode: '',
        pan: '',
        gst: '',
        panNumber: '',
        gstCompanyName: '',

        planType: '',
        planId: '',
        // selectedSolutionMaster: '',
        timezone: { value: 'Asia/Kolkata', label: 'Asia/Kolkata' },
        typeOfClient: 'REAL',
        // customerType: 'International',\
        customerAcquisitionType: '',
        directCustomer: '',
        directCustomerType: '',
        directCustomerSAPCode: '',
        indirectCustomerType: '',
        channelPartnerType: '',
        indirectCustomerName: '',
        registrationType: '',
        customerLocation: '',
        customerAddress: '',
        response: true,
        expiryDateTime: moment().add(1, 'week'),
        solution: '',
        billingMode: '',
        salesPerson: '',
        showFields: false,
        selectedMode: { label: 'Taabi Pro', value: 'taabi_pro' },
        selectedVTM: 'none',
        selectedServiceType: 'portal',
        selectedZM: null,
        selectedSM: null,
        selectedKAM: null,
        selectedStateManager: null,
        selectedTerritoryManager: null,
        selectedSalesHead: null,
        selectedClusterHead: null,
        selectedStateHead: null,
        selectedCityManager: null,
        selectedOperationsManager: null,
        zone: null,
        serviceManager: null,
        customerSuccessManager: null,
        channelPartnerName: '',
        channelPartnerSAPCode: '',
        is_sim_tracking: false,
        customerNameToBeDisplayed: '',
        totalPotentialVehicles: ''
      })
      this.props.history.push({
        pathname: '/home/customers/'
      })
    } else {
      this.props.openSnackbar(errors[0].message)
    }
    // }
  }

  cancelForm = e => {
    // this.setState({
    //   name: '',
    //   username: '',
    //   person: '',
    //   password: '',
    //   email: '',
    //   phoneno: '',
    //   address1: '',
    //   address2: '',
    //   city: '',
    //   state: '',
    //   country: '',
    //   pincode: '',
    //   pan: '',
    //   gst: '',
    //   plan: '',
    //   timezone: '',
    //   typeOfClient: 'REAL',
    //   expiryDateTime: moment().add(1, 'week')
    // })
    this.props.history.goBack()
  }

  getGstInfo = async gstNumber => {
    const fetchGstData = await this.props.client.query({
      query: GET_GST_INFO,
      variables: {
        gstNumber: gstNumber
      }
    })

    this.setState({
      isGstInfoAvailable: fetchGstData.data.getGstDetails.status === 'SUCCESS',
      panNumber:
        fetchGstData.data.getGstDetails.panNumber != null
          ? fetchGstData.data.getGstDetails.panNumber
          : null,
      gstCompanyName:
        fetchGstData.data.getGstDetails.companyName != null
          ? fetchGstData.data.getGstDetails.companyName
          : null,
      address:
        fetchGstData.data.getGstDetails.address != null
          ? fetchGstData.data.getGstDetails.address
          : null,
      pincode:
        fetchGstData.data.getGstDetails.pinCode != null
          ? fetchGstData.data.getGstDetails.pinCode
          : null
    })
  }

  handlePincodeChange = event => {
    const enteredPincode = event.target.value
    let isValid

    if (this.state.country === 99) {
      isValid = /^\d{6}$/.test(enteredPincode)
    } else {
      isValid = true
    }

    this.setState({
      pincode: enteredPincode,
      pincodeError: !isValid
    })

    if (isValid) {
      this.getStateAndCityByPin(enteredPincode)
    }
  }

  getStateAndCityByPin = enteredPincode => {
    this.props.client
      .query({
        query: GET_STATE_DETAILS_BY_PINCODE,
        variables: { pincode: enteredPincode }
      })
      .then(response => {
        const { data } = response

        console.log('Response data:', data)

        if (data && data.getStateDetailsByPincode) {
          console.log('fetched')
          const stateData = data.getStateDetailsByPincode
          const stateName = stateData.statename
          const cityName = stateData.districtname

          // this.setState({
          //   state: stateData.statename,
          //   city: stateData.districtname,
          // });
          this.props.client
            .query({
              query: GET_STATES_FOR_COUNTRY,
              variables: { countryId: Number(this.state.country) || 99 }
            })
            .then(stateResponse => {
              const states = stateResponse.data.allStatesByCountryId
              const selectedState = states.find(
                state => state.name.toLowerCase() === stateName.toLowerCase()
              )

              if (selectedState) {
                this.setState({
                  state: stateName,
                  city: cityName,
                  stateId: selectedState.zone_id
                })
              } else {
                console.error('State not found in the country list')
              }
            })
            .catch(err => {
              console.error('Error fetching states by country:', err)
            })
        }
      })
      .catch(error => {
        console.error('Error fetching state and city:', error)
      })
  }

  fetchPlans = () => {
    const { partnerLoginId } = this.state

    this.props.client
      .query({
        query: GET_ALL_PLANS,
        variables: { partnerLoginId }
      })
      .then(response => {
        const { data } = response
        console.log('Plans fetched:', data)

        if (data && data.allPlans) {
          console.log('Plans data:', data.allPlans)

          this.setState({
            plans: data.allPlans
          })
        }
      })
      .catch(error => {
        console.error('Error fetching plans:', error)
      })
  }

  getChannelPartnerDetailsNew = () => {
    this.props.client
      .query({
        query: GET_CHANNEL_PARTNER_DETAILS
      })
      .then(response => {
        const { data } = response

        if (data && data.getChannelPartnerDetails) {
          console.log(
            'getChannelPartnerDetailsNew fetched:',
            data.getChannelPartnerDetails
          )

          this.setState({
            channelPartnerSAPCodeNew: data.getChannelPartnerDetails
          })
        }
      })
      .catch(error => {
        console.error('Error fetching plans:', error)
      })
  }

  isSaveFormInvalid() {
    const {
      customerType,
      customerAcquisitionType,
      directCustomerType,
      directCustomer,
      indirectCustomerType,
      channelPartnerType,
      channelPartnerName,
      customerLocation,
      customerAddress,
      country,
      pincode,
      state,
      city,
      timezone,
      zone,
      selectedZM,
      selectedSM,
      selectedKAM,
      serviceManager,
      customerSuccessManager,
      isUsernameValid,
      isPasswordValid,
      customerNameToBeDisplayed,
      totalPotentialVehicles,
      contactPerson,
      isContactpValid1,
      contactNumber,
      isPhonenoValid1,
      isPhoneExists,
      landlineNumberError,
      isEmailValid1,
      isEmailExists,
      isContactpValid2,
      isPhonenoValid2,
      secondaryLandlineNumberError,
      isEmailValid2,
      selectedMode,
      selectedPlan,
      // selectedSolutionMaster,
      planId,
      selectedServiceType,
      isSecondaryContact,
      secondaryContactName,
      secondaryContactNumber,
      secondaryEmail,
      clientNameRes,
      isAdditionalContact,
      additionalContactNumbers,
      isAdditionalContactValid
    } = this.state

    return (
      customerType === '' ||
      customerAcquisitionType === '' ||
      (customerAcquisitionType === 'Direct Customer' &&
        (directCustomerType === '' || directCustomer === '')) ||
      (customerAcquisitionType === 'Indirect Customer' &&
        (channelPartnerType === '' ||
          indirectCustomerType === '' ||
          channelPartnerName === '')) ||
      customerLocation === '' ||
      customerAddress === '' ||
      country === '' ||
      pincode === '' ||
      state === '' ||
      city === '' ||
      timezone === '' ||
      // zone === '' ||
      // !selectedZM ||
      // !selectedSM ||
      // !selectedKAM ||
      // serviceManager === '' ||
      // customerSuccessManager === '' ||
      !isUsernameValid ||
      !isPasswordValid ||
      clientNameRes ||
      (this.state.customerAcquisitionType === 'Direct Customer'
        ? this.state.customerNameToBeDisplayed ||
          (this.state.directCustomer ? this.state.directCustomer.label : '')
        : this.state.customerAcquisitionType === 'Indirect Customer'
          ? this.state.customerNameToBeDisplayed ||
            this.state.indirectCustomerName
          : this.state.customerNameToBeDisplayed || '') === '' ||
      totalPotentialVehicles === '' ||
      contactPerson === '' ||
      !isContactpValid1 ||
      contactNumber === '' ||
      !isPhonenoValid1 ||
      !isPhoneExists ||
      landlineNumberError ||
      !isEmailValid1 ||
      !isEmailExists ||
      !selectedMode ||
      // !selectedPlan ||
      // (!selectedSolutionMaster || !selectedSolutionMaster.value) ||
      // planId === '' ||
      !selectedServiceType ||
      (isSecondaryContact &&
        (!secondaryContactName ||
          !isContactpValid2 ||
          !isPhonenoValid2 ||
          secondaryLandlineNumberError ||
          !isEmailValid2 ||
          !secondaryContactNumber ||
          !secondaryEmail)) ||
      (isAdditionalContact &&
        (!additionalContactNumbers || !isAdditionalContactValid))
    )
  }

  render() {
    // console.log(this.props)
    const {
      // name,
      id,
      username,
      clientName,
      companyName,
      contactPerson,
      secondaryContactName,
      password,
      email,
      secondaryEmail,
      contactNumber,
      landlineNumber,
      secondaryContactNumber,
      secondaryLandlineNumber,
      address,
      address2,
      shippingAddress,
      shippingAddres2,
      shippingCountry,
      shippingState,
      shippingCity,
      shippingPincode,
      minimumTrackedDays,
      packetThreshold,
      prorata,
      addressEffectiveDate,

      city,

      state,
      state2,
      country,
      countryTwo,
      pincode,
      isGstInfoAvailable,
      panNumber,
      gstCompanyName,
      gstErrorFieldText,
      pan,
      gst,
      plan,
      typeOfClient,
      customerType,
      customerAcquisitionType,
      directCustomer,
      directCustomerType,
      indirectCustomerType,
      channelPartnerType,
      customerLocation,
      customerAddress,
      registrationType,
      solution,
      billingMode,
      salesPerson,
      allSalesPerson,
      packetsPerDay
    } = this.state

    const { classes } = this.props
    const {
      showFields,
      selectedZM,
      selectedSM,
      selectedKAM,
      selectedTerritoryManager,
      selectedSalesHead,
      selectedClusterHead,
      selectedStateHead,
      selectedCityManager,
      selectedOperationsManager,
      zone,
      serviceManager,
      customerSuccessManager,
      selectedPlan,
      selectedVTM,
      selectedServiceType,
      channelPartnerName,
      selectedMode,
      clientCategory,
      clientCategoryOptions,
      actionDashboardType,
      actionDashboardTypeOptions,
      zonalManagers,
      stateManagers,
      territoryManagers,
      salesHeads,
      clusterHeads,
      stateHeads,
      cityManagers,
      operationsManagers,
      keyAccountManagers,
      serviceManagers,
      customerSuccessManagers
    } = this.state
    return (
      <ApolloConsumer>
        {client => (
          // <Query
          //   query={GET_ALL_PLANS} // Fetch Billing Modes here
          //   variables={{
          //     partnerLoginId: getLoginId()
          //   }}
          // >
          //   {({ loading, error, data: { allPlans } }) => {
          //     if (loading) return <Loader />

          //     if (error) return `Error!: ${error}`
          //     const plans = allPlans.map(plan => ({
          //       value: plan.id,
          //       label: plan.planName
          //     }))
          <Query
            query={GET_ALL_SOLUTION_TYPE_MASTER}
            fetchPolicy="network-only"
          >
            {({ loading, error, data }) => {
              if (loading) return <Loader />
              if (error) return `Error!: ${error}`

              // Map solutions to value/label format
              const solutionsMaster = data.getAllMasterSolutionType.map(
                solution => ({
                  value: solution.id,
                  label: solution.solutionTypeName
                })
              )

              return (
                <div className={classes.root}>
                  <ConfirmationalDialog
                    isDialogOpen={this.state.isSaveConfDialogOpen}
                    dialogMessage={
                      "Are you sure you want to Save this customer's details?"
                    }
                    negativeResponseHandler={this.handleSaveNegativeResponse}
                    positiveResponseHandler={this.submitForm}
                  />
                  <ConfirmationalDialog
                    isDialogOpen={this.state.isCancelConfDialogOpen}
                    dialogMessage={
                      'Are you sure you want to Cancel customer registration?'
                    }
                    negativeResponseHandler={this.handleCancelNegativeResponse}
                    positiveResponseHandler={this.cancelForm}
                  />
                  <Grid container spacing={16}>
                    <Grid item container xs={12} justify="flex-start">
                      <Button
                        variant="outlined"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleBackCancelClick}
                      >
                        <ArrowBackIcon />
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Card sx={{ marginTop: '400px' }}>
                        <CardHeader
                          title="Register Customer"
                          subheader="All fields marked with (*) are mandatory"
                          subheaderTypographyProps={{
                            className: classes.italicizedText
                          }}
                        />
                        <CardContent>
                          <Grid container spacing={16}>
                            {/* <Grid item xs={12} md={6}>
                              <FormControl>
                                <RadioGroup
                                  aria-label="position"
                                  name="position"
                                  value={typeOfClient}
                                  onChange={this.handleTypeChange}
                                  row
                                >
                                  <FormControlLabel
                                    value="REAL"
                                    control={<Radio color="primary" />}
                                    label="Billable"
                                    labelPlacement="end"
                                  />
                                  <FormControlLabel
                                    value="DEMO"
                                    control={<Radio color="primary" />}
                                    label="Non-Billable"
                                    labelPlacement="end"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>  */}
                            {/* <Grid item xs={12} md={12}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="clientName"
                                  value={clientName}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  onInput={e =>
                                    (e.target.value = (
                                      '' + e.target.value
                                    ).toUpperCase())
                                  }
                                  required
                                  label="Company Name"
                                />
                              </FormGroup>
                            </Grid> */}

                            <Grid item xs={12} md={6} style={{ zIndex: '20' }}>
                              <label>Customer Type *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '10px' }}
                              >
                                <Select
                                  // options={CUSTOMER_TYPES}
                                  options={
                                    Array.isArray(this.state.customertype) &&
                                    this.state.customertype.map(option => ({
                                      label: option,
                                      value: option
                                    }))
                                  }
                                  value={this.state.customerType}
                                  onChange={this.handleCustomerTypeChange}
                                  placeholder="Select Customer Type *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid item xs={12} md={6} style={{ zIndex: '15' }}>
                              <label>Customer Acquisition Type *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '10px' }}
                              >
                                <Select
                                  // options={CUSTOMER_ACQUISITION_TYPES}
                                  options={
                                    Array.isArray(
                                      this.state.customeracquisitiontype
                                    ) &&
                                    this.state.customeracquisitiontype.map(
                                      option => ({
                                        label: option,
                                        value: option
                                      })
                                    )
                                  }
                                  value={this.state.customerAcquisitionType}
                                  onChange={
                                    this.handleCustomerAcquisitionTypeChange
                                  }
                                  placeholder="Select Customer Acquisition Type *"
                                  // onBlur={(event) => {this.checkNameValidity(client)(event)}}
                                />
                              </FormGroup>
                            </Grid>

                            {this.state.customerAcquisitionType ===
                              'Direct Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '15' }}
                              >
                                <label>Direct Customer Type *</label>
                                <FormGroup
                                  className="form-input"
                                  style={{ marginTop: '10px' }}
                                >
                                  <Select
                                    // options={DIRECT_CUSTOMER_TYPE_OPTIONS}
                                    options={
                                      Array.isArray(
                                        this.state.directcustomertype
                                      ) &&
                                      this.state.directcustomertype.map(
                                        option => ({
                                          label: option,
                                          value: option
                                        })
                                      )
                                    }
                                    value={this.state.directCustomerType}
                                    onChange={selectedOption => {
                                      this.setState({
                                        directCustomerType: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }}
                                    required
                                    placeholder="Select Direct Customer Type *"
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.customerAcquisitionType ===
                              'Direct Customer' && (
                              <Grid
                                item
                                xs={6}
                                style={{ zIndex: '13', marginTop: '5px' }}
                              >
                                <label>Direct Customer Name *</label>
                                <FormGroup
                                  className="form-input"
                                  style={{ marginTop: '5px' }}
                                >
                                  <Query query={GET_SAP_DETAILS}>
                                    {({ loading, error, data }) => {
                                      if (loading) return 'Loading...'
                                      if (error)
                                        return `Error!: ${error.message}`

                                      const newCustomers = data.getSapDetails.map(
                                        customer => ({
                                          value: customer.customer_no,
                                          label: customer.customer_name
                                        })
                                      )

                                      return (
                                        <div>
                                          <Select
                                            options={newCustomers}
                                            value={this.state.directCustomer}
                                            onChange={selectedOption => {
                                              this.setState({
                                                directCustomer: selectedOption,
                                                directCustomerSAPCode: selectedOption
                                                  ? selectedOption.value
                                                  : '',
                                                customerNameToBeDisplayed: selectedOption
                                                  ? selectedOption.label
                                                  : ''
                                              })
                                            }}
                                            required
                                            placeholder="Select Direct Customer Name *"
                                            onBlur={event => {
                                              this.checkNameValidity(client)(
                                                event
                                              )
                                            }}
                                          />
                                        </div>
                                      )
                                    }}
                                  </Query>
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.customerAcquisitionType ===
                              'Direct Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '13' }}
                              >
                                <FormGroup
                                  className="form-input"
                                  style={{ marginTop: '5px' }}
                                >
                                  <label>Direct Customer SAP Code</label>
                                  <TextField
                                    id="directCustomerSAPCode"
                                    name="directCustomerSAPCode"
                                    className="textfield"
                                    margin="dense"
                                    // label="Direct Customer SAP Code"
                                    type="text"
                                    value={this.state.directCustomerSAPCode}
                                    onChange={this.handleInputChange(
                                      'directCustomerSAPCode'
                                    )}
                                    InputProps={{ readOnly: true }}
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.customerAcquisitionType ===
                              'Indirect Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '15' }}
                              >
                                <label>Indirect Customer Type *</label>
                                <FormGroup
                                  className="form-input"
                                  style={{ marginTop: '10px' }}
                                >
                                  <Select
                                    // options={INDIRECT_CUSTOMER_TYPE_OPTIONS}
                                    options={
                                      Array.isArray(
                                        this.state.indirectcustomertype
                                      ) &&
                                      this.state.indirectcustomertype.map(
                                        option => ({
                                          label: option,
                                          value: option
                                        })
                                      )
                                    }
                                    value={this.state.indirectCustomerType}
                                    onChange={selectedOption => {
                                      this.setState({
                                        indirectCustomerType: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }}
                                    required
                                    placeholder="Select Indirect Customer Type *"
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.customerAcquisitionType ===
                              'Indirect Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '13', marginTop: '10px' }}
                              >
                                <FormGroup className="form-input">
                                  <TextField
                                    id="indirectCustomerName"
                                    name="indirectCustomerName"
                                    className="textfield"
                                    margin="dense"
                                    label="Indirect Customer Name"
                                    type="text"
                                    value={this.state.indirectCustomerName}
                                    onChange={this.handleInputChangeIndirectCustomerName(
                                      'indirectCustomerName'
                                    )}
                                    onBlur={event => {
                                      this.checkNameValidity(client)(event)
                                    }}
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.customerAcquisitionType ===
                              'Indirect Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '12' }}
                              >
                                <label>Channel Partner Name *</label>
                                <FormGroup
                                  className="form-input"
                                  style={{ marginTop: '10px' }}
                                >
                                  <Select
                                    // options={CHANNEL_PARTNER_OPTIONS}
                                    // value={this.state.channelPartnerName}
                                    // onChange={(selectedOption) => {
                                    //   this.setState({ channelPartnerName: selectedOption ? selectedOption.value : '' });
                                    // }}
                                    // options={Array.isArray(this.state.channelpartners) && this.state.channelpartners.map(option => ({
                                    //   label: option,
                                    //   value: option
                                    // }))}

                                    options={
                                      this.state.channelPartnerSAPCodeNew &&
                                      this.state.channelPartnerSAPCodeNew.map(
                                        option => ({
                                          label: option.channel_partner_name,
                                          value: option.channel_partner_name
                                        })
                                      )
                                    }
                                    value={this.state.channelPartnerName}
                                    // onChange = {(selectedOption) => {
                                    //   this.setState({ channelPartnerName: selectedOption
                                    //     ? selectedOption.value
                                    //     : '',
                                    //     channelPartnerSAPCode: this.state.channelPartnerSAPCodeNew.filter(customer =>
                                    //       customer.customer_name === selectedOption.value
                                    //     )
                                    //   });
                                    // }}
                                    onChange={selectedOption => {
                                      this.setState({
                                        channelPartnerName: selectedOption
                                          ? selectedOption.value
                                          : '',
                                        channelPartnerSAPCode: selectedOption
                                          ? this.state.channelPartnerSAPCodeNew.find(
                                              customer =>
                                                customer.channel_partner_name ===
                                                selectedOption.value
                                            )
                                            ? this.state.channelPartnerSAPCodeNew.find(
                                                customer =>
                                                  customer.channel_partner_name ===
                                                  selectedOption.value
                                              ).channel_partner_sap_code
                                            : '99999999'
                                          : '',
                                        channelPartnerType: selectedOption
                                          ? this.state.channelPartnerSAPCodeNew.find(
                                              customer =>
                                                customer.channel_partner_name ===
                                                selectedOption.value
                                            )
                                            ? this.state.channelPartnerSAPCodeNew.find(
                                                customer =>
                                                  customer.channel_partner_name ===
                                                  selectedOption.value
                                              ).channel_partner_type
                                            : 'N/A'
                                          : ''
                                      })
                                    }}
                                    required
                                    placeholder="Select Channel Partner Name *"
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {/* {this.state.customerAcquisitionType === 'Indirect Customer' && (
                              <Grid item xs={12} md={6} style={{ zIndex: '8' }}>
                              <label>Channel Partner Type *</label>
                              <FormGroup className="form-input" style={{ marginTop: '10px' }}>
                                <Select
                                  // options={INDIRECT_CUSTOMER_TYPE_OPTIONS}
                                  options={Array.isArray(this.state.channelpartnertype) && this.state.channelpartnertype.map(option => ({
                                    label: option,
                                    value: option
                                  }))}
                                  value={this.state.channelPartnerType}
                                  onChange={(selectedOption) => {
                                    this.setState({ channelPartnerType: selectedOption ? selectedOption.value : '' });
                                  }}
                                  required
                                  placeholder="Select Channel Partner Type *"
                                />
                              </FormGroup>
                            </Grid>
                            )} */}

                            {this.state.customerAcquisitionType ===
                              'Indirect Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '2', marginTop: '10px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Channel Partner Type</label>
                                  <TextField
                                    id="channelPartnerType"
                                    name="channelPartnerType"
                                    className="textfield"
                                    margin="dense"
                                    // label="Channel Partner SAP Code"
                                    type="text"
                                    value={this.state.channelPartnerType}
                                    onChange={this.handleInputChange(
                                      'channelPartnerType'
                                    )}
                                    InputProps={{ readOnly: true }}
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.customerAcquisitionType ===
                              'Indirect Customer' && (
                              <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ zIndex: '2', marginTop: '10px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Channel Partner SAP Code</label>
                                  <TextField
                                    id="channelPartnerSAPCode"
                                    name="channelPartnerSAPCode"
                                    className="textfield"
                                    margin="dense"
                                    // label="Channel Partner SAP Code"
                                    type="text"
                                    value={this.state.channelPartnerSAPCode}
                                    onChange={this.handleInputChange(
                                      'channelPartnerSAPCode'
                                    )}
                                    InputProps={{ readOnly: true }}
                                  />
                                </FormGroup>
                              </Grid>
                            )}

                            {/* {this.state.customerAcquisitionType === 'Indirect Customer' && (
                              <Grid item xs={12} md={6} style={{ zIndex: '3' }}>
                              <FormGroup className="form-input">
                              <TextField
                                  id="indirectCustomerUniqueId"
                                  name="indirectCustomerUniqueId"
                                  className="textfield"
                                  margin="dense"
                                  label="Indirect Customer Unique ID"
                                  type="text"
                                  value={this.state.indirectCustomerUniqueId}
                                  onChange={this.handleInputChange(
                                    'indirectCustomerName'
                                  )}
                              />
                              </FormGroup>
                            </Grid>)} */}

                            <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>Location Info</p>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ zIndex: '7', marginTop: '-20px' }}
                            >
                              <label>Customer Location *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '5px' }}
                              >
                                <Select
                                  // options={CUSTOMER_LOCATIONS}
                                  options={
                                    Array.isArray(
                                      this.state.customerlocation
                                    ) &&
                                    this.state.customerlocation.map(option => ({
                                      label: option,
                                      value: option
                                    }))
                                  }
                                  value={this.state.customerLocation}
                                  onChange={selectedOption => {
                                    this.setState({
                                      customerLocation: selectedOption || ''
                                    })
                                  }}
                                  required
                                  placeholder="Select Customer Location *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '-10px' }}
                            >
                              <FormGroup className="form-input">
                                <TextField
                                  name="customerAddress"
                                  value={this.state.customerAddress}
                                  type="text"
                                  onChange={this.handleInputChange(
                                    'customerAddress'
                                  )}
                                  label="Enter Customer Address *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={6}
                              style={{ zIndex: '6', marginTop: '5px' }}
                            >
                              <label>Country *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '5px' }}
                              >
                                <Query query={GET_COUNTRIES}>
                                  {({
                                    loading,
                                    error,
                                    data: { allCountries }
                                  }) => {
                                    if (loading) return 'Loading...'
                                    if (error) return `Error!: ${error}`

                                    const sortedCountries = allCountries.map(
                                      country => ({
                                        value: country.country_id,
                                        label: country.name
                                      })
                                    )

                                    return (
                                      <div>
                                        <Select
                                          // classes={classes}
                                          options={sortedCountries}
                                          // components={components}
                                          value={this.state.country}
                                          onChange={selectedOption => {
                                            this.setState({
                                              country: selectedOption
                                                ? selectedOption.value
                                                : ''
                                            })
                                          }}
                                          required
                                          placeholder="Select Country *"
                                        />
                                      </div>
                                    )
                                  }}
                                </Query>{' '}
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '15px' }}
                            >
                              <FormGroup className="form-input">
                                <TextField
                                  name="pincode"
                                  value={this.state.pincode}
                                  type="text"
                                  onChange={this.handlePincodeChange}
                                  label="Enter PIN Code *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={6}
                              style={{ zIndex: '5', marginTop: '5px' }}
                            >
                              <label>State *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '5px' }}
                              >
                                <Query
                                  query={GET_STATES_FOR_COUNTRY}
                                  variables={{
                                    countryId: Number(this.state.country)
                                      ? this.state.country
                                      : 99
                                  }}
                                >
                                  {({ loading, error, data }) => {
                                    if (loading) return 'Loading...'
                                    if (error) return `Error!: ${error}`

                                    if (data && data.allStatesByCountryId) {
                                      const sortedStates = data.allStatesByCountryId.map(
                                        state => ({
                                          value: state.zone_id,
                                          label: state.name
                                        })
                                      )

                                      if (sortedStates.length > 0) {
                                        return (
                                          <div>
                                            <Select
                                              options={sortedStates}
                                              value={
                                                sortedStates.find(
                                                  option =>
                                                    option.label.toLowerCase() ===
                                                    (this.state.state
                                                      ? this.state.state.toLowerCase()
                                                      : '')
                                                ) || null
                                              }
                                              onChange={selectedOption => {
                                                this.setState({
                                                  state: selectedOption
                                                    ? selectedOption.label
                                                    : '',
                                                  stateId: selectedOption
                                                    ? selectedOption.value
                                                    : ''
                                                })
                                              }}
                                              required
                                              placeholder="Select State *"
                                            />
                                          </div>
                                        )
                                      } else {
                                        return (
                                          <TextField
                                            value="No States in this Country"
                                            type="text"
                                          />
                                        )
                                      }
                                    }

                                    return null
                                  }}
                                </Query>
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '15px' }}
                            >
                              <FormGroup className="form-input">
                                <TextField
                                  name="city"
                                  value={this.state.city}
                                  type="text"
                                  onChange={this.handleInputChange('city')}
                                  label="Enter City *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ zIndex: '4', marginTop: '5px' }}
                            >
                              <label>Time Zone *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '5px' }}
                              >
                                <Select
                                  options={this.state.timezoneList}
                                  value={this.state.timezone}
                                  onChange={this.handleTimezoneChange}
                                  placeholder="Select Time Zone *"
                                />
                              </FormGroup>
                            </Grid>

                            {/* <Grid item xs={12} md={6} style={{ zIndex: '3', marginTop: '5px' }}>
                              <label>Zone *</label>
                              <FormGroup className="form-input" style={{ marginTop: '5px' }}>
                                <Select
                                  options={ZONE_OPTIONS}
                                  value={this.state.zone}
                                  onChange = {(selectedOption) => {
                                    this.setState({ zone: selectedOption 
                                      ? selectedOption.value 
                                      : '' });
                                  }}
                                  placeholder="Select Zone *"
                                />
                              </FormGroup>
                            </Grid> */}

                            {/* <Grid item xs={12} md={6} style={{ zIndex: '3' }}>
                              <label>Zonal Manager *</label>
                              <FormGroup className="form-input" style={{ marginTop: '10px' }}>
                                <Select
                                  options={ZM_OPTIONS}
                                  value={this.state.zonalManager}
                                  onChange={(selectedOption) => {
                                    this.setState({ zonalManager: selectedOption 
                                      ? selectedOption.value 
                                      : '' });
                                  }}
                                  placeholder="Select Zonal Manager *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid item xs={12} md={6} style={{ zIndex: '3' }}>
                              <label>Key Account Manager *</label>
                              <FormGroup className="form-input" style={{ marginTop: '10px' }}>
                                <Select
                                  options={KAM_OPTIONS}
                                  value={this.state.keyAccountManager}
                                  onChange={(selectedOption) => {
                                    this.setState({ keyAccountManager: selectedOption 
                                      ? selectedOption.value 
                                      : '' });
                                  }}
                                  placeholder="Key Account Manager *"
                                />
                              </FormGroup>
                            </Grid> */}

                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={TYPE_OF_CLIENT}
                                  value={typeOfClient}
                                  onChange={this.handleClientType}
                                  placeholder="Type Of Client*"
                                  required
                                />
                              </FormGroup>
                            </Grid> */}
                            {/* <Button variant="contained" color="primary" onClick={this.handleToggle}>
                            {showFields ? 'Hide' : 'Show'} Fields
                          </Button> */}

                            {/* <Grid container spacing={2}>
                              <Grid item>
                                <label style={{ marginRight: '20px' }}>
                                  Through Channel Partner :{' '}
                                </label>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={showFields}
                                      onChange={this.handleToggle}
                                      color="primary"
                                    />
                                  }
                                />
                              </Grid>
                            </Grid> */}

                            <Query
                              query={GET_ZM_KAM_SM_CSM_DETAILS}
                              variables={{ roleName: roleNames }}
                              fetchPolicy="network-only"
                            >
                              {({ loading, error, data }) => {
                                if (loading) return <Loader />
                                if (error) return `Error!: ${error.message}`

                                const zonalManagers = data.getAdminUserDetailsByRole.filter(
                                  user => user.role === 'Zonal Manager(ZM)'
                                )
                                const stateManagers = data.getAdminUserDetailsByRole.filter(
                                  user => user.role === 'State Manager(SM)'
                                )
                                const keyAccountManagers = data.getAdminUserDetailsByRole.filter(
                                  user =>
                                    user.role === 'Key Account Manager(KAM)'
                                )
                                const serviceManagers = data.getAdminUserDetailsByRole.filter(
                                  user => user.role === 'Service Manager'
                                )
                                const customerSuccessManagers = data.getAdminUserDetailsByRole.filter(
                                  user =>
                                    user.role === 'Customer Success Manager'
                                )
                                // return !showFields ? (
                                return (
                                  <Grid
                                    container
                                    spacing={2}
                                    style={{ marginTop: '20px' }}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ zIndex: '3', marginTop: '5px' }}
                                    >
                                      <label>Zone *</label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={ZONE_OPTIONS}
                                          value={this.state.zone}
                                          onChange={selectedOption => {
                                            this.setState({
                                              zone: selectedOption
                                                ? selectedOption.value
                                                : ''
                                            })
                                          }}
                                          placeholder="Select Zone"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '5px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Zonal Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={zonalManagers.map(zm => ({
                                            label: zm.username,
                                            value: zm.id
                                          }))}
                                          // options={Array.isArray(this.state.zonalmanager) && this.state.zonalmanager.map(option => ({
                                          //   label: option,
                                          //   value: option
                                          // }))}
                                          value={this.state.selectedZM}
                                          onChange={this.handleZMChange}
                                          placeholder="Select Zonal Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        State Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={stateManagers.map(sm => ({
                                            label: sm.username,
                                            value: sm.id
                                          }))}
                                          // options={Array.isArray(this.state.zonalmanager) && this.state.zonalmanager.map(option => ({
                                          //   label: option,
                                          //   value: option
                                          // }))}
                                          value={this.state.selectedSM}
                                          onChange={this.handleSMChange}
                                          placeholder="Select State Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Territory Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={territoryManagers}
                                          value={
                                            this.state.selectedTerritoryManager
                                          }
                                          onChange={
                                            this.handleTerritoryManagerChange
                                          }
                                          placeholder="Select Territory Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Sales Head
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={salesHeads}
                                          value={this.state.selectedSalesHead}
                                          onChange={this.handleSalesHeadChange}
                                          placeholder="Select Sales Head"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Cluster Head
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={clusterHeads}
                                          value={this.state.selectedClusterHead}
                                          onChange={
                                            this.handleClusterHeadChange
                                          }
                                          placeholder="Select Cluster Head"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        State Head
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={stateHeads}
                                          value={this.state.selectedStateHead}
                                          onChange={this.handleStateHeadChange}
                                          placeholder="Select State Head"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        City Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={cityManagers}
                                          value={this.state.selectedCityManager}
                                          onChange={
                                            this.handleCityManagerChange
                                          }
                                          placeholder="Select City Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Operations Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={operationsManagers}
                                          value={
                                            this.state.selectedOperationsManager
                                          }
                                          onChange={
                                            this.handleOperationsManagerChange
                                          }
                                          placeholder="Select Operations Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Key Account Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          options={keyAccountManagers.map(
                                            kam => ({
                                              label: kam.username,
                                              value: kam.id
                                            })
                                          )}
                                          // options={Array.isArray(this.state.keyaccountmanager) && this.state.keyaccountmanager.map(option => ({
                                          //   label: option,
                                          //   value: option
                                          // }))}
                                          value={this.state.selectedKAM}
                                          onChange={this.handleKAMChange}
                                          placeholder="Select Key Account Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Service Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          // options={SERVICE_MANAGER_OPTIONS}
                                          // options={Array.isArray(this.state.servicemanager) && this.state.servicemanager.map(option => ({
                                          //   label: option,
                                          //   value: option
                                          // }))}
                                          options={serviceManagers.map(sm => ({
                                            label: sm.username,
                                            value: sm.id
                                          }))}
                                          value={this.state.serviceManager}
                                          onChange={selectedOption => {
                                            this.setState({
                                              serviceManager: selectedOption
                                                ? selectedOption.value
                                                : ''
                                            })
                                          }}
                                          placeholder="Select Service Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      style={{ marginTop: '15px' }}
                                    >
                                      <label style={{ marginRight: '20px' }}>
                                        Customer Success Manager
                                      </label>
                                      <FormGroup
                                        className="form-input"
                                        style={{ marginTop: '5px' }}
                                      >
                                        <Select
                                          // options={CUSTOMER_SUCCESS_MANAGER_OPTIONS}
                                          // options={Array.isArray(this.state.customersuccessmanager) && this.state.customersuccessmanager.map(option => ({
                                          //   label: option,
                                          //   value: option
                                          // }))}
                                          options={customerSuccessManagers.map(
                                            csm => ({
                                              label: csm.username,
                                              value: csm.id
                                            })
                                          )}
                                          value={
                                            this.state.customerSuccessManager
                                          }
                                          onChange={selectedOption => {
                                            this.setState({
                                              customerSuccessManager: selectedOption
                                                ? selectedOption.value
                                                : ''
                                            })
                                          }}
                                          placeholder="Select Customer Success Manager"
                                        />
                                      </FormGroup>
                                    </Grid>
                                  </Grid>
                                  // ) : (
                                  //   <React.Fragment>
                                  //     <Grid container spacing={2}>
                                  //       <Grid item xs={12} md={6}>
                                  //         <label style={{ marginRight: '20px' }}>
                                  //           Zonal Manager *
                                  //         </label>
                                  //         <FormGroup className="form-input" style={{ marginTop: '5px' }}>
                                  //           <Select
                                  //             // options={zonalManagers.map(zm => ({
                                  //             //   label: zm.username,
                                  //             //   value: zm.id
                                  //             // }))}
                                  //             options={Array.isArray(this.state.zonalmanager) && this.state.zonalmanager.map(option => ({
                                  //               label: option,
                                  //               value: option
                                  //             }))}
                                  //             value={this.state.selectedZM}
                                  //             onChange={this.handleZMChange}
                                  //             placeholder="Select Zonal Manager *"
                                  //           />
                                  //         </FormGroup>
                                  //       </Grid>
                                  //       <Grid item xs={12} md={6}>
                                  //         <label style={{ marginRight: '20px' }}>
                                  //           Key Account Manager *
                                  //         </label>
                                  //         <FormGroup className="form-input">
                                  //           <Select
                                  //             // options={keyAccountManagers.map(
                                  //             //   kam => ({
                                  //             //     label: kam.username,
                                  //             //     value: kam.id
                                  //             //   })
                                  //             // )}
                                  //             options={Array.isArray(this.state.keyaccountmanager) && this.state.keyaccountmanager.map(option => ({
                                  //               label: option,
                                  //               value: option
                                  //             }))}
                                  //             value={selectedKAM}
                                  //             onChange={this.handleKAMChange}
                                  //             placeholder="Select Key Account Manager *"
                                  //           />
                                  //         </FormGroup>
                                  //       </Grid>
                                  //     </Grid>

                                  //     {/* <Grid item xs={12} md={6}>
                                  //       <label style={{ marginRight: '20px' }}>
                                  //         Channel Partner Name *
                                  //       </label>
                                  //       <FormGroup className="form-input">
                                  //         <TextField
                                  //           value={channelPartnerName}
                                  //           placeholder="Enter Channel Partner Name *"
                                  //           fullWidth
                                  //           onChange={
                                  //             this.handleChannelPartnerNameChange
                                  //           }
                                  //         />
                                  //       </FormGroup>
                                  //     </Grid> */}
                                  //   </React.Fragment>
                                )
                              }}
                            </Query>

                            {/* <Grid item xs={12} md={6}>
                              <TextField
                                label="Total potential vehicles"
                                type="number"
                                value={this.state.totalPotentialVehicles}
                                onChange={this.handleInputChange}
                                inputProps={{
                                  name: 'totalPotentialVehicles',
                                  min: 0,
                                  step: 1
                                }}
                                fullWidth
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <DateTimePicker
                                label="Expiry Date &amp; Time"
                                disabled={
                                  typeOfClient.value === 'REAL' ||
                                  typeOfClient == 'REAL' ||
                                  typeOfClient === ''
                                }
                                value={this.state.expiryDateTime}
                                onChange={this.handleDateTimeChange}
                                inputProps={{
                                  name: 'expiryDateTime'
                                }}
                              />
                            </Grid> */}
                            {/* {customerType === 'Registered' && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="gst"
                                    value={gst}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="GST"
                                    required
                                    error={!this.state.isGSTValid}
                                    onBlur={() =>
                                      this.checkGSTValidity(this.state.gst)
                                    }
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {gstErrorFieldText}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}
                            {(customerType === 'Registered' ||
                              customerType === 'Unegistered') && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="pan"
                                    value={
                                      this.state.panNumber != null
                                        ? this.state.panNumber
                                        : null
                                    }
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="PAN"
                                    required
                                    disabled
                                    error={!this.state.isPanValid}
                                    onBlur={this.checkPanValidity(client)}
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {this.state.isPanExists
                                      ? ''
                                      : 'Pan No. Already Exists'}
                                    {this.state.isPanValid
                                      ? ''
                                      : 'Invalid Pan Number'}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )} */}
                            {/* <Grid item xs={12} md={12}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="clientName"
                                  value={
                                    this.state.customerType == 'Registered'
                                      ? this.state.gstCompanyName != null
                                        ? this.state.gstCompanyName
                                        : null
                                      : clientName
                                  }
                                  type="text"
                                  onChange={this.handleInputChange}
                                  onInput={e =>
                                    (e.target.value = (
                                      '' + e.target.value
                                    ).toUpperCase())
                                  }
                                  required
                                  disabled={
                                    this.state.customerType == 'Registered'
                                  }
                                  label="Company Name"
                                  error={!this.state.isNameValid}
                                  onBlur={this.checkNameValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isNameValid ? '' : 'Invalid'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={SOLUTION_TYPES}
                                  value={solution}
                                  onChange={this.handleSolutionChange}
                                  placeholder="Select Solution*"
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                              <Select
                               options={PORTAL_MODES}
                                value={selectedMode}
                                onChange={this.handleModeChange}
                                placeholder="Select Mode *"
                              />
                              </FormGroup>
                            </Grid> */}

                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={VIDEO_TELEMATICS_TYPE}
                                  value={selectedVTM}
                                  onChange={this.handleVideoTelematicsMenuChange}
                                  placeholder="Video Telematics"
                                />
                              </FormGroup>
                            </Grid> */}
                            {getLoginId() === 2 && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <Select
                                    options={allSalesPerson}
                                    value={salesPerson}
                                    onChange={this.handleSalesPersonChange}
                                    placeholder="Select Sales Person*"
                                  />
                                </FormGroup>
                              </Grid>
                            )}
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="username"
                                  value={username}
                                  type="text"
                                  onChange={
                                    this.handleInputChangeUsernamePassword
                                  }
                                  required
                                  error={!this.state.isUsernameValid}
                                  onBlur={this.checkUsernameValidity(client)}
                                  label="User Name"
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isUsernameValid
                                    ? this.state.usernameRes
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="password"
                                  value={password}
                                  type="password"
                                  onChange={
                                    this.handleInputChangeUsernamePassword
                                  }
                                  label="Password"
                                  error={!this.state.isPasswordValid}
                                  onBlur={this.checkPasswordValidity}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPasswordValid
                                    ? ''
                                    : 'Password should contain 3-20 charcter or digit without space'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            {/* <Grid item xs={12} md={12}>
                              <FormGroup className="form-input" display="flex">
                              <label>
                              <Checkbox
                                name="prorata"
                                value={prorata}
                                checked={prorata}
                                onClick={this.handleProrataCheckboxChange}
                                onChange={this.setProrata}
                              />
                              <span style={{ fontSize: '20px' }}>
                                Prorata Billing
                              </span>
                              </label>
                              </FormGroup>
                            </Grid>
                            {this.state.prorata ? (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="packetThreshold"
                                    value={packetThreshold}
                                    type="text"
                                    onChange={this.handleProrata}
                                    label="Packets per Day"
                                    required
                                  />
                                </FormGroup>
                              </Grid>
                            ) : null}
                            {this.state.prorata ? (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="minimumTrackedDays"
                                    value={minimumTrackedDays}
                                    type="text"
                                    onChange={this.handleProrata}
                                    label="Minium Tracking Days"
                                    required
                                  />
                                </FormGroup>
                              </Grid>
                            ) : null} */}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="name"
                                  value={name}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Full Name"
                                  onInput={(e) => (e.target.value = (""+e.target.value).toUpperCase())}
                                  required
                                  error={!this.state.isNameValid}
                                  onBlur={this.checkNameValidity(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isNameValid
                                    ? ''
                                    : this.state.clientNameRes}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}

                            {/* {typeOfClient.value === 'NON-COMMERCIAL' && (
                              <Grid item xs={12} md={6}>
                                <DateTimePicker
                                  label="Expiry Date &amp; Time 11"
                                  // disabled={typeOfClient === 'REAL'}
                                  value={this.state.expiryDateTime}
                                  onChange={this.handleDateTimeChange}
                                  inputProps={{
                                    name: 'expiryDateTime'
                                  }}
                                />
                              </Grid>
                            )} */}
                            {/* <Grid item xs={12} md={6}>
                              <DateTimePicker
                                label="Expiry Date &amp; Time 11"
                                disabled={typeOfClient === 'REAL'}
                                value={this.state.expiryDateTime}
                                onChange={this.handleDateTimeChange}
                                inputProps={{
                                  name: 'expiryDateTime'
                                }}
                              />
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={BILLING_MODES}
                                  value={billingMode}
                                  onChange={this.hanldeBillingModeChange}
                                  placeholder="Select Billing Mode*"
                                />
                              </FormGroup>
                            </Grid> */}

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '10px' }}
                            >
                              <FormGroup className="form-input">
                                <label>
                                  Customer Name to be displayed on Portal *
                                </label>
                                <TextField
                                  name="customerNameToBeDisplayed"
                                  value={
                                    this.state.customerAcquisitionType ===
                                    'Direct Customer'
                                      ? this.state.customerNameToBeDisplayed ||
                                        (this.state.directCustomer
                                          ? this.state.directCustomer.label
                                          : '')
                                      : this.state.customerAcquisitionType ===
                                        'Indirect Customer'
                                        ? this.state
                                            .customerNameToBeDisplayed ||
                                          this.state.indirectCustomerName
                                        : this.state
                                            .customerNameToBeDisplayed || ''
                                  }
                                  type="text"
                                  onChange={this.handleInputChange(
                                    'customerNameToBeDisplayed'
                                  )}
                                  error={!this.state.isNameValid}
                                  // onBlur={this.checkNameValidity}
                                  onBlur={event => {
                                    this.checkNameValidity(client)(event)
                                  }}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.clientNameRes}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '10px' }}
                            >
                              <FormGroup className="form-input">
                                <label>Customer Potential *</label>
                                <TextField
                                  name="totalPotentialVehicles"
                                  value={this.state.totalPotentialVehicles}
                                  type="number"
                                  onChange={this.handleInputChange(
                                    'totalPotentialVehicles'
                                  )}
                                  inputProps={{
                                    name: 'totalPotentialVehicles',
                                    min: 1,
                                    step: 1
                                  }}
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '10px' }}
                            >
                              <FormGroup className="form-input">
                                <label>Client Category *</label>
                                <Select
                                  options={this.state.clientCategoryOptions}
                                  value={this.state.clientCategoryOptions.find(
                                    option =>
                                      option.value === this.state.clientCategory
                                  )}
                                  onChange={selectedOption => {
                                    this.setState({
                                      clientCategory: selectedOption.value
                                    })
                                  }}
                                  placeholder="Select Client Category *"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '10px' }}
                            >
                              <FormGroup className="form-input">
                                <label>Action Dashboard Customer Type</label>
                                <Select
                                  options={actionDashboardTypeOptions}
                                  value={actionDashboardTypeOptions.find(
                                    option =>
                                      option.value === actionDashboardType
                                  ) || null}
                                  onChange={selectedOption => {
                                    this.setState({
                                      actionDashboardType: selectedOption
                                        ? selectedOption.value
                                        : ''
                                    })
                                  }}
                                  placeholder="Select Action Dashboard Type"
                                  isClearable
                                />
                              </FormGroup>
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>Contact Info</p>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="contactPerson"
                                  value={this.state.contactPerson}
                                  type="text"
                                  onChange={this.handleInputChange(
                                    'primaryContactPersonName'
                                  )}
                                  label="Primary Contact Person Name"
                                  required
                                  error={!this.state.isContactpValid1}
                                  onBlur={this.checkContactpValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isContactpValid1
                                    ? ''
                                    : 'Only Alphabets allowed, between 3 to 32 characters'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="secondaryContactName"
                                  value={secondaryContactName}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Secondary Contact Person"
                                  error={!this.state.isContactpValid2}
                                  onBlur={this.checkContactpValidityTwo}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isContactpValid2
                                    ? ''
                                    : 'Only Alphabets allowed, between 3 to 32 characters'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="secondaryEmail"
                                  value={secondaryEmail}
                                  type="email"
                                  onChange={this.handleInputChange}
                                  label="Secondary Email"
                                  error={!this.state.isEmailValid2}
                                  onBlur={this.checkEmailValidity2(
                                    this.props.client
                                  )}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isEmailValid2
                                    ? ''
                                    : 'Invalid Email'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="contactNumber"
                                  value={this.state.contactNumber}
                                  type="text"
                                  onChange={this.handleInputChange(
                                    'primaryContactPersonMobileNumber'
                                  )}
                                  label="Primary Mobile Number"
                                  required
                                  error={!this.state.isPhonenoValid1}
                                  onBlur={this.checkPhonenoValidity1(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPhonenoValid1
                                    ? ''
                                    : 'Invalid Phone Number '}
                                  {this.state.isPhoneExists
                                    ? ''
                                    : 'Phone Number Already Exists '}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="landlineNumber"
                                  value={this.state.landlineNumber}
                                  type="text"
                                  onChange={this.handleInputChange(
                                    'primaryContactPersonLandlineNumber'
                                  )}
                                  label="Landline Number"
                                  onBlur={event =>
                                    this.checkLandlineValidity(
                                      event,
                                      'landlineNumber'
                                    )
                                  }
                                  error={this.state.landlineNumberError}
                                  // helperText={this.state.landlineNumberError}
                                />
                                <FormHelperText
                                  id="landline-error-text"
                                  className="Error_msg"
                                  error={this.state.landlineNumberError}
                                >
                                  {this.state.landlineNumberError}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="email"
                                  value={email}
                                  type="email"
                                  onChange={this.handleInputChange(
                                    'primaryContactPersonEmail'
                                  )}
                                  label="Primary Email"
                                  required
                                  error={!this.state.isEmailValid1}
                                  onBlur={this.checkEmailValidity1(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isEmailExists
                                    ? ''
                                    : 'Email Id already exist '}
                                  {this.state.isEmailValid1
                                    ? ' '
                                    : 'Invalid Email '}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>

                            <Grid item xs={12} md={12} display="flex">
                              <Checkbox
                                name="isSecondaryContact"
                                value={this.state.isSecondaryContact}
                                checked={this.state.isSecondaryContact}
                                onClick={this.handleSecondaryContactAvailable}
                              />
                              <span style={{ fontSize: '15px' }}>
                                Secondary Contact Details Available?
                              </span>
                            </Grid>

                            {/* <FormControlLabel
                            style={{ marginTop: '20px' }}
                            label="Secondary Contact Details Available?"
                            control={
                              <Checkbox
                              name="isSecondaryContact"
                              value={this.state.isSecondaryContact}
                              checked={this.state.isSecondaryContact}
                              onClick={this.handleSecondaryContactAvailable}
                              />
                              } 
                            /> */}

                            {this.state.isSecondaryContact && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="secondaryContactName"
                                    value={this.state.secondaryContactName}
                                    type="text"
                                    onChange={this.handleInputChange(
                                      'secondaryContactPersonName'
                                    )}
                                    label="Secondary Contact Person Name *"
                                    error={!this.state.isContactpValid2}
                                    onBlur={this.checkContactpValidityTwo}
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {this.state.isContactpValid2
                                      ? ''
                                      : 'Only Alphabets allowed, between 3 to 32 characters'}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.isSecondaryContact && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="secondaryContactNumber"
                                    value={this.state.secondaryContactNumber}
                                    type="text"
                                    onChange={this.handleInputChange(
                                      'secondaryContactPersonPhoneNumber'
                                    )}
                                    label="Secondary Phone Number *"
                                    error={!this.state.isPhonenoValid2}
                                    onBlur={this.checkPhonenoValidity2(client)}
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {this.state.isPhonenoValid2
                                      ? ''
                                      : // : 'Invalid phone Number'}
                                        this.state.phonenoRes2}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.isSecondaryContact && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="secondaryLandlineNumber"
                                    value={this.state.secondaryLandlineNumber}
                                    type="text"
                                    onChange={this.handleInputChange(
                                      'secondaryContactPersonLandlineNumber'
                                    )}
                                    label="Landline Number"
                                    onBlur={event =>
                                      this.checkLandlineValidity(
                                        event,
                                        'secondaryLandlineNumber'
                                      )
                                    }
                                    error={
                                      !this.state.isSecondaryLandlineNumberValid
                                    }
                                    // helperText={this.state.secondaryLandlineNumberError}
                                  />
                                  <FormHelperText
                                    id="landline-error-text"
                                    className="Error_msg"
                                    error={
                                      this.state.secondaryLandlineNumberError
                                    }
                                  >
                                    {this.state.secondaryLandlineNumberError}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}

                            {this.state.isSecondaryContact && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="secondaryEmail"
                                    value={this.state.secondaryEmail}
                                    type="email"
                                    onChange={this.handleInputChange(
                                      'secondaryContactPersonEmail'
                                    )}
                                    label="Secondary Email *"
                                    error={!this.state.isEmailValid2}
                                    onBlur={this.checkEmailValidity2(
                                      this.props.client
                                    )}
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {this.state.isEmailValid2
                                      ? ''
                                      : // : 'Invalid Email'}
                                        this.state.emailRes2}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}

                            {/* <Grid item xs={12} md={12}>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.isAdditionalContact}
                                      onChange={this.handleAdditionalContactAvailable}
                                      color="primary"
                                    />
                                  }
                                  label="Additional Contact Details Available?"
                                />
                              </FormGroup>
                            </Grid> */}
                            {this.state.isSecondaryContact && (
                              <Grid item xs={12} md={12} display="flex">
                                <Checkbox
                                  name="isAdditionalContact"
                                  value={this.state.isAdditionalContact}
                                  checked={this.state.isAdditionalContact}
                                  onClick={
                                    this.handleAdditionalContactAvailable
                                  }
                                />
                                <span style={{ fontSize: '15px' }}>
                                  Additional Contact Details Available?
                                </span>
                              </Grid>
                            )}
                            {this.state.isSecondaryContact &&
                              this.state.isAdditionalContact && (
                                <React.Fragment>
                                  <Grid item xs={12} md={6}>
                                    <FormGroup className="form-input">
                                      <TextField
                                        name="additionalContactNumbers"
                                        label="Additional Contact Numbers (comma separated) *"
                                        value={
                                          this.state.additionalContactNumbers
                                        }
                                        onChange={
                                          this.handleAdditionalContactChange
                                        }
                                        onBlur={
                                          this.checkAdditionalContactValidity
                                        }
                                        fullWidth
                                        error={
                                          !this.state.isAdditionalContactValid
                                        }
                                        helperText={
                                          this.state.additionalContactError
                                        }
                                      />
                                    </FormGroup>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    {/* Empty grid item to maintain layout alignment */}
                                  </Grid>
                                </React.Fragment>
                              )}

                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="secondaryContactNumber"
                                  value={secondaryContactNumber}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Secondary Phone Number"
                                  error={!this.state.isPhonenoValid2}
                                  onBlur={this.checkPhonenoValidity2(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPhonenoValid2
                                    ? ''
                                    : 'Invalid phone Number'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>
                                Billing Address
                              </p>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="address"
                                  value={address}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 1"
                                  required
                                  error={!this.state.isAddressValid}
                                  onBlur={this.checkAddressValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isAddressValid
                                    ? ''
                                    : 'Address should be between 5 to 200 characters without spaces at Start and End.'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="address2"
                                  value={address2}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 2"
                                  required
                                  error={!this.state.isAddressValid}
                                  onBlur={this.checkAddressValidity2}
                                />
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={6}>
                              <FormGroup className="form-input">
                                <TextField
                                      // autoComplete="username"
                                          name="country"
                                          value={this.props.country}
                                          type="text"
                                          onChange={this.props.handleInputChange}
                                          placeholder="Country"
                                          required
                                          // error={!isUsernameValid}
                                          handleCountryChange={this.props.handleCountryChange}
                                          />
                                        </FormGroup>
                                              </Grid>        // onBlur={this.checkUsernameValidity}
                                           // label={!isUsernameValid ? 'Invalid Username' : ''}
                                        />
                                <Countries
                                  value={this.country}
                                  handleCountryChange={this.handleCountryChange}
                                />
                                <Query query={GET_COUNTRIES}>
                                  {({
                                    loading,
                                    error,
                                    data: { allCountries }
                                  }) => {
                                    if (loading) return 'Loading...'
                                    if (error) return `Error!: ${error}`

                                    const sortedCountries = allCountries.map(
                                      country => ({
                                        value: country.country_id,
                                        label: country.name
                                      })
                                    )

                                    return (
                                      <div>
                                        <Select
                                          // classes={classes}
                                          options={sortedCountries}
                                          // components={components}
                                          value={country}
                                          onChange={this.handleCountryChange}
                                          placeholder="Select Country *"
                                        />
                                      </div>
                                    )
                                  }}
                                </Query>
                              </FormGroup>
                            </Grid>

                            {this.state.country && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <Query
                                    query={GET_STATES_FOR_COUNTRY}
                                    variables={{
                                      countryId: country
                                    }}
                                  >
                                    {({
                                      loading,
                                      error,
                                      data: { allStatesByCountryId }
                                    }) => {
                                      if (loading) return 'Loading...'
                                      if (error) return `Error: ${error}`

                                      const allStates = allStatesByCountryId.map(
                                        s => {
                                          return {
                                            value: s.zone_id,
                                            label: s.name
                                          }
                                        }
                                      )

                                      if (allStates.length > 0) {
                                        return (
                                          <Select
                                            options={allStates}
                                            value={state}
                                            onChange={this.handleStateChange}
                                            placeholder="Select State *"
                                          />
                                        )
                                      } else {
                                        return (
                                          <TextField
                                            value="No States in this Country"
                                            type="text"
                                          />
                                        )
                                      }
                                    }}
                                  </Query>
                                </FormGroup>
                              </Grid>
                            )} */}

                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="state"
                                  value={state}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="State"
                                  required
                                />
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="city"
                                  value={city}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="City"
                                  required
                                  error={!this.state.isCityValid}
                                  onBlur={() => {
                                    this.checkCityValidity('billing')
                                  }}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isCityValid ? '' : 'Invalid City'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="pincode"
                                  value={pincode}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Pin"
                                  required
                                  error={!this.state.isPinValid}
                                  onBlur={this.checkPinValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPinValid ? '' : 'Invalid Pin'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            {/* <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>
                                Shipping Address
                              </p>
                            </Grid>
                            <Grid item xs={12} md={12} display="flex">
                              <FormGroup className="form-input" display="flex">
                              <label>
                              <Checkbox
                                name="shipping"
                                value={this.state.shippingmode}
                                // checked={
                                //   // this.state.shippingmode
                                //   // ? this.setState({ shippingmode: true })
                                //   // : this.setState({ shippingmode: false })
                                // }
                                onClick={this.handleShipping}
                              />

                              <span style={{ fontSize: '15px' }}>
                                Same as billing
                              </span>
                              </label>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingAddress"
                                  value={shippingAddress}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 1"
                                  error={!this.state.isShippingAddressValid}
                                  onBlur={this.checkShippingAddressValidity}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isShippingAddressValid
                                    ? ''
                                    : 'Shipping Address should be between 5 to 200 characters without spaces at Start and End.'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingAddress2"
                                  value={shippingAddres2}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 2"
                                  error={!this.state.isAddressValid}
                                  onBlur={this.checkAddressValidity2}
                                />
                              </FormGroup>
                            </Grid>

                            <Grid item xs={6}>
                              <FormGroup className="form-input">
                                <Query query={GET_COUNTRIES}>
                                  {({
                                    loading,
                                    error,
                                    data: { allCountries }
                                  }) => {
                                    if (loading) return 'Loading...'
                                    if (error) return `Error!: ${error}`

                                    const sortedCountries = allCountries.map(
                                      country => ({
                                        value: country.country_id,
                                        label: country.name
                                      })
                                    )

                                    return (
                                      <div>
                                        <Select
                                          // classes={classes}
                                          options={sortedCountries}
                                          // components={components}
                                          value={shippingCountry}
                                          onChange={
                                            this.handleSecondaryCountryChange
                                          }
                                          placeholder="Select Country *"
                                        />
                                      </div>
                                    )
                                  }}
                                </Query>{' '}
                              </FormGroup>
                            </Grid>

                            {this.state.shipping ? (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <Select
                                    value={state}
                                    placeholder="Select State *"
                                  />
                                </FormGroup>
                              </Grid>
                            ) : (
                              this.state.shippingCountry && (
                                <Grid item xs={12} md={6}>
                                  <FormGroup className="form-input">
                                    <Query
                                      query={GET_STATES_FOR_COUNTRY}
                                      variables={{
                                        countryId: shippingCountry
                                      }}
                                    >
                                      {({
                                        loading,
                                        error,
                                        data: { allStatesByCountryId }
                                      }) => {
                                        if (loading) return 'Loading...'
                                        if (error) return `Error: ${error}`

                                        const allStates = allStatesByCountryId.map(
                                          s => {
                                            return {
                                              value: s.zone_id,
                                              label: s.name
                                            }
                                          }
                                        )

                                        if (allStates.length > 0) {
                                          return (
                                            <Select
                                              options={allStates}
                                              value={shippingState}
                                              onChange={
                                                this.handleStateChangeTwo
                                              }
                                              placeholder="Select State *"
                                            />
                                          )
                                        } else {
                                          return (
                                            <TextField
                                              value="No States in this Country"
                                              type="text"
                                            />
                                          )
                                        }
                                      }}
                                    </Query>
                                  </FormGroup>
                                  {
                                    this.state.shipping && 
                                  }
                                </Grid>
                              )
                            )}
                            
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="state2"
                                  value={this.state.shipping ? state : state2}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="State"
                                  required
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingCity"
                                  value={shippingCity}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="City"
                                  error={!this.state.isShippingCityValid}
                                  onBlur={() => {
                                    this.checkCityValidity('shipping')
                                  }}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isShippingCityValid
                                    ? ''
                                    : 'Invalid City'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingPincode"
                                  value={shippingPincode}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Pin"
                                  // error={!this.state.isPinValid}
                                  error={!this.state.isShippingPinvalid}
                                  onBlur={this.checkPinValidity2}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isShippingPinvalid
                                    ? ''
                                    : 'Invalid Pin'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '20px' }}
                            >
                              <label>Mode *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '10px' }}
                              >
                                <Select
                                  options={
                                    Array.isArray(this.state.mode) &&
                                    this.state.mode.map(option => ({
                                      label: option,
                                      value: option
                                    }))
                                  }
                                  value={this.state.selectedMode}
                                  onChange={this.handleModeChange}
                                  placeholder="Select Mode *"
                                />
                              </FormGroup>
                            </Grid>

                            {/* <Grid item xs={12} md={6} style={{ marginTop: '20px' }}> */}

                            {/* <label>Plan *</label> */}
                            {/* <label>Solution *</label> */}
                            {/* <FormGroup className="form-input" style={{ marginTop: '10px' }}> */}
                            {/* <Select
                                  options={plans}
                                  value={this.state.selectedPlan}
                                  onChange={this.handlePlanChange}
                                  placeholder="Select Plan *"
                                /> */}
                            {/* <Select
                                  options={solutionsMaster}
                                  value={this.state.selectedSolutionMaster}
                                  onChange={this.handleSolutionMasterChange}
                                  placeholder="Select Solution *"
                                />
                              </FormGroup> */}
                            {/* </Grid> */}

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '20px' }}
                            >
                              <label>Video Telematics Plan *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '10px' }}
                              >
                                <Select
                                  // options={Array.isArray(this.state.videotelematicsplan) && this.state.videotelematicsplan.map(option => ({
                                  //   label: option,
                                  //   value: option
                                  // }))}
                                  options={
                                    Array.isArray(
                                      this.state.videotelematicsplan
                                    ) &&
                                    this.state.videotelematicsplan.map(
                                      option => ({
                                        label: option,
                                        value:
                                          option === 'API-Loconav'
                                            ? 'loconav'
                                            : option === 'API-Meta'
                                              ? 'mettax'
                                              : option === 'iFrame-LM'
                                                ? 'lightMetrics'
                                                : option === 'None'
                                                  ? 'none'
                                                  : option.toLowerCase()
                                      })
                                    )
                                  }
                                  value={this.state.selectedVTM || 'none'}
                                  // value={this.state.selectedVTM === 'none' ? { label: 'None', value: 'none' } : this.state.selectedVTM}
                                  onChange={
                                    this.handleVideoTelematicsMenuChange
                                  }
                                  placeholder="Select Video Telematics Plan *"
                                  menuStyle={{ height: '120px' }}
                                />
                              </FormGroup>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={6}
                              style={{ marginTop: '20px' }}
                            >
                              <label>Service Type *</label>
                              <FormGroup
                                className="form-input"
                                style={{ marginTop: '10px' }}
                              >
                                <Select
                                  options={
                                    Array.isArray(this.state.servicetype) &&
                                    this.state.servicetype.map(option => ({
                                      label: option,
                                      value: option.toLowerCase()
                                    }))
                                  }
                                  value={
                                    this.state.selectedServiceType === 'portal'
                                      ? { label: 'Portal', value: 'portal' }
                                      : this.state.selectedServiceType
                                  }
                                  onChange={this.handleServiceTypeChange}
                                  placeholder="Select Service Type *"
                                  menuStyle={{ height: '120px' }}
                                />
                              </FormGroup>
                            </Grid>

                            <Grid item xs={12} md={12} display="flex">
                              <Checkbox
                                name="is_sim_tracking"
                                value={this.state.is_sim_tracking}
                                checked={this.state.is_sim_tracking}
                                onClick={this.handleSimTracking}
                              />
                              <span style={{ fontSize: '15px' }}>
                                SIM tracking enabled?
                              </span>
                            </Grid>

                            {/* <Grid item xs={12}>
                              <CustomTabs
                                address={address}
                                city={city}
                                state={state}
                                country={country}
                                pincode={pincode}
                                pan={pan}
                                gst={gst}
                                isAddressValidity={this.checkCityValidity}
                                checkPinValidity={this.checkPinValidity}
                                checkPanValidity={this.checkPanValidity(client)}
                                checkGSTValidity={this.checkGSTValidity(client)}
                                panNoRes={this.state.panNoRes}
                                gstNoRes={this.state.gstNoRes}
                              />
                            </Grid> */}
                          </Grid>
                        </CardContent>
                        <CardActions>
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.submitForm}
                            disabled={this.isSaveFormInvalid()}
                            // disabled={
                            //   this.state.isEmailValid1 === false ||
                            //   // this.state.isEmailValid2 === false ||
                            //   this.state.isContactpValid1 === false ||
                            //   // this.state.isContactpValid2 === false ||
                            //   this.state.isPhonenoValid1 === false ||
                            //   // this.state.isPhonenoValid2 === false ||
                            //   this.state.isCityValid === false ||
                            //   this.state.isShippingAddressValid === false ||
                            //   this.state.isShippingCityValid === false ||
                            //   this.state.isPinValid === false ||
                            //   this.state.isPanValid === false ||
                            //   this.state.isAddressValid === false ||
                            //   // this.state.isUsernameValid === false ||
                            //   // this.state.isNameValid === false ||
                            //   // this.state.isPasswordValid === false ||
                            //   // this.state.isUsernameUnique === false ||
                            //   this.state.isGSTValid === false ||
                            //   (this.state.customerType === 'Registered' &&
                            //     this.state.gst === '') ||
                            //   (this.state.customerType === 'Registered' &&
                            //     this.state.panNumber === '') ||
                            //   (this.state.customerType === 'Registered' &&
                            //     this.state.gstCompanyName === '') ||
                            //   this.state.isShippingPinvalid === false ||
                            //   solution === '' ||
                            //   // clientName === '' ||
                            //   username === '' ||
                            //   // contactPerson === '' ||
                            //   // secondaryContactName === '' ||
                            //   salesPerson === '' ||
                            //   password === '' ||
                            //   email === '' ||
                            //   packetThreshold === '' ||
                            //   minimumTrackedDays === '' ||
                            //   // packetThreshold === null ||
                            //   // minimumTrackedDays === null
                            //   // secondaryEmail === '' ||
                            //   // secondaryContactNumber === '' ||
                            //   // contactNumber === '' ||
                            //   typeOfClient === '' ||
                            //   pincode === '' ||
                            //   address === '' ||
                            //   city === '' ||
                            //   state === '' ||
                            //   country === '' ||
                            //   // this.state.shippingmode === false ||
                            //   // plan === '' ||
                            //   this.state.shippingAddress === '' ||
                            //   this.state.shippingState === null ||
                            //   state === null ||
                            //   this.state.shippingCity === '' ||
                            //   this.state.shippingState === '' ||
                            //   this.state.shippingCountry === '' ||
                            //   this.state.shippingPincode === '' ||
                            //   this.state.timezone === '' ||
                            //   billingMode === '' ||
                            //   this.state.selectedZM === '' ||
                            //   this.state.selectedZM === null ||
                            //   this.state.selectedMode === '' ||
                            //   this.state.selectedMode === null ||
                            //   this.state.selectedKAM === '' ||
                            //   this.state.selectedKAM === null ||
                            //   this.state.zone === '' ||
                            //   this.state.serviceManager === '' ||
                            //   this.state.customerSuccessManager === '' ||
                            //   (showFields &&
                            //     this.state.channelPartnerName === '') ||
                            //   (showFields &&
                            //     this.state.channelPartnerName === null)
                            // }
                          >
                            Save
                          </Button>
                          <Button
                            color="secondary"
                            onClick={this.handleCancelClick}
                          >
                            Cancel
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  </Grid>
                </div>
              )
            }}
          </Query>
        )}
      </ApolloConsumer>
    )
  }
}

RegisterCustomer.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(
  withApollo(withSharedSnackbar(RegisterCustomer))
)



// WEBPACK FOOTER //
// ./src/components/Pages/RegisterCustomer/index.jsx